// Debug mode resolution (?itgdebug=1 | alert | eruda | all). The value is
// persisted in sessionStorage so it survives Shopify preview redirects that
// strip query params. "all" enables every debug facility. Inert for real
// users. window.onerror is installed before everything else so even early
// crashes are visible on devices without a remote inspector.
window.__itgDebug = (function () {
  var mode = '';
  try { mode = sessionStorage.getItem('itgdebug') || ''; } catch (eDbg) {}
  var m = window.location.search.match(/[?&]itgdebug=([^&]+)/);
  if (m) {
    mode = m[1];
    try { sessionStorage.setItem('itgdebug', mode); } catch (eDbg2) {}
  }
  return mode;
})();
function itgDebugHas(kind) {
  return window.__itgDebug === kind || window.__itgDebug === 'all';
}
if (itgDebugHas('alert')) {
  window.onerror = function (message, source, lineno, colno) {
    var errFile = source ? String(source).split('/').pop().split('?')[0] : 'unknown';
    alert('[ITG JS ERROR]\n' + message + '\n' + errFile + ':' + lineno + ':' + colno);
    return false;
  };
}

// Shared cart helpers — single source of truth, defined at file top level so
// every closure below can reach them. Namespaced (itg*) to avoid collisions
// with third-party globals.
window.itgGetCart = async function itgGetCart() {
  // no-store + cache-buster: Safari otherwise serves a stale /cart.js from
  // its HTTP cache after navigation.
  const res = await fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' });
  return res.json();
};
window.itgIsVariantInCart = function itgIsVariantInCart(cart, variantId) {
  return cart.items.some(item => String(item.id) === String(variantId));
};
// Resolves the currently selected variant ids from the LIVE option inputs
// (checked pills / dropdown values), mirroring the combination logic of
// handleAddonVariants exactly. This is the same source the add flow reads,
// which matters on iOS: WebKit restores checked pills/selects on
// back-navigation and reload WITHOUT firing change events, so the
// .itg_variant_option span[selected] markers (synced only by change
// handlers) go stale there — the add was correctly refused while the button
// kept saying "Add to cart". Return contract:
//   null  → no pill/dropdown option UI, or nothing selected yet: caller
//           falls back to the server-rendered span[selected] markers
//   []    → selection incomplete / resolves to no real variant
//   [ids] → resolved variant ids (strings)
window.itgGetSelectedVariantIds = function itgGetSelectedVariantIds() {
  function optionValues(idx) {
    var vals = [];
    document.querySelectorAll('.pill_option_' + idx + ' input[type="checkbox"]:checked').forEach(function (cb) { vals.push(cb.value); });
    if (vals.length) return vals;
    var radio = document.querySelector('.pill_option_' + idx + ' input[type="radio"]:checked');
    if (radio) return [radio.value];
    var select = document.querySelector('.product-form__input.dropdown_option_' + idx + ' select');
    if (select && select.value) return [select.value];
    return [];
  }
  // attribute comparison instead of a [title="..."] selector: variant titles
  // may contain quotes (e.g. 35" putter lengths), which break the selector
  function idForTitle(title) {
    var spans = document.querySelectorAll('.itg_variant_option span');
    for (var i = 0; i < spans.length; i++) {
      if (spans[i].getAttribute('title') === title) return spans[i].getAttribute('data-variant-id');
    }
    return null;
  }
  var option1El = document.querySelector('fieldset.pill_option_1') || document.querySelector('.product-form__input.dropdown_option_1');
  var option2El = document.querySelector('fieldset.pill_option_2') || document.querySelector('.product-form__input.dropdown_option_2');
  if (!option1El) return null;
  var option1Values = optionValues(1);
  if (!option1Values.length) return null;
  var option3Value = '';
  var o3radio = document.querySelector('.pill_option_3 input[type="radio"]:checked');
  if (o3radio) {
    option3Value = o3radio.value;
  } else {
    var o3select = document.querySelector('.product-form__input.dropdown_option_3 select');
    if (o3select) option3Value = o3select.value;
  }
  var titles = [];
  if (option2El) {
    var option2Values = optionValues(2);
    option1Values.forEach(function (opt1) {
      option2Values.forEach(function (opt2) {
        titles.push(option3Value ? opt1 + ' / ' + opt2 + ' / ' + option3Value : opt1 + ' / ' + opt2);
      });
    });
  } else {
    titles = option1Values.slice();
  }
  var ids = [];
  titles.forEach(function (title) {
    var id = idForTitle(title);
    if (id) ids.push(id);
  });
  return ids;
};

function validateBusinessCheckbox() {
    var checkbox = document.getElementById("Business");
    if(checkbox){
      var checkboxChecked = checkbox.checked;
      var buttons = document.querySelectorAll(".itg_ctm_addtocart .product-form__buttons");

      if (checkboxChecked) {
          buttons.forEach(function(button) {
              button.classList.remove("itg_checked_class");
          });
          checkbox.classList.remove("red_color");
          checkbox.classList.remove("itg-error");
      } else {
          buttons.forEach(function(button) {
              button.classList.add("itg_checked_class");
          });
          checkbox.classList.add("red_color");
          checkbox.classList.add("itg-error");
      }
    }  
}
var suffix = document.querySelector('body').getAttribute('data-template');
var swiper = new Swiper(".services_slider", {
  speed: 1000,
  centeredSlides: false,
  slidesPerGroupSkip: 1,
  grabCursor: true,
  spaceBetween: 30,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1300: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
  },
});

var swiper = new Swiper(".reviews_slider", {
  speed: 1000,
  centeredSlides: false,
  slidesPerGroupSkip: 1,
  grabCursor: true,
  spaceBetween: 30,
  loop: true,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1300: {
      slidesPerView: 2.3,
      slidesPerGroup: 1,
    },
    750: {
      slidesPerView: 1.2,
      spaceBetween: 20,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
      slidesPerGroup: 1,
    },
  },
});

var swiper = new Swiper(".itg_brand_slider", {
  speed: 1000,
  centeredSlides: false,
  slidesPerGroupSkip: 1,
  grabCursor: true,
  spaceBetween: 30,
  loop: true,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1300: {
      slidesPerView: 5,
      slidesPerGroup: 1,
    },
    750: {
      slidesPerView: 4,
      spaceBetween: 20,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
      slidesPerGroup: 1,
    },
  },
});

var swiper = new Swiper(".itg_submenu_moblie", {
  speed: 1000,
  centeredSlides: false,
  autoplay: true,
  grabCursor: true,
  breakpoints: {
    750: {
      slidesPerView: 3,
      spaceBetween: 15,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
      slidesPerGroup: 1,
    },
  },
});

$(document).ready(function () {
  AOS.init();
  $(document).on("click", ".itg_main_header_open", function (e) {
    var $this = $(this);
    var isActive = $this
      .find("ul.itg_main_header_1, ul.itg_main_header_2")
      .hasClass("active");
    $(".itg_main_header_open")
      .find("ul.itg_main_header_1, ul.itg_main_header_2")
      .removeClass("active");
    if (!isActive) {
      $this
        .find("ul.itg_main_header_1, ul.itg_main_header_2")
        .addClass("active");
    }
    e.stopPropagation();
  });
  $(document).on("click", function () {
    $(".itg_main_header_open")
      .find("ul.itg_main_header_1, ul.itg_main_header_2")
      .removeClass("active");
  });

  $(document).on("click", "ul.itg_pro_tab_head li", function (e) {
    $("ul.itg_pro_tab_head li").removeClass("active");
    $(this).addClass("active");
    var a = $(this).attr("data-id");
    $(".itg_pro_tab_content_part").removeClass("active");
    $(".itg_pro_tab_content_part").each(function (index) {
      var b = $(this).attr("data-id");
      if (a == b) {
        $(this).addClass("active");
      }
    });

    // Land the tab content just below the sticky tab bar, which itself parks
    // below the sticky header — otherwise the top of the content hides behind both.

    var $section = $(this).closest(".itg_pro_tab");
    var $content = $section.find(".itg_pro_tab_content");
    if ($content.length) {
      var barHeight = $section.find(".itg_pro_tab_head_wrap").outerHeight() || 0;
      var targetTop = $content.offset().top - itgStickyTabOffset() - barHeight - 20;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: "smooth" });
    }
  });

  // Where sticky tab bars park: the sticky header's height at the destination
  // plus the gap. --header-bottom-position is only set while the menu drawer is
  // open, so it can't be used here. Mirrors the --itg-sticky-offset switch in
  // header.liquid: past the header it is the slim height, unless a header panel
  // is expanded.
  function itgStickyTabOffset() {
    var root = document.documentElement;
    var styles = getComputedStyle(root);
    var full = parseFloat(styles.getPropertyValue("--itg-header-h")) || 0;
    var slim = parseFloat(styles.getPropertyValue("--itg-header-h-slim")) || full;
    var gap = parseFloat(styles.getPropertyValue("--itg-sticky-gap")) || 0;
    var header = root.classList.contains("itg-panel-expanded") ? full : slim;
    return header + gap;
  }

  $(document).on("click", ".itg_pro_tab_acc_head", function (e) {
    e.preventDefault();
    var $head = $(this);
    var $part = $head.closest(".itg_pro_tab_content_part");
    var $siblings = $part.parent().children(".itg_pro_tab_content_part");
    var wasActive = $part.hasClass("active");
    var dataId = $head.attr("data-id");

    $siblings.removeClass("active");
    $siblings.find("> .itg_pro_tab_acc_head").attr("aria-expanded", "false");
    $("ul.itg_pro_tab_head li").removeClass("active");

    var headerOffset = itgStickyTabOffset();


    if (!wasActive) {
      $part.addClass("active");
      $head.attr("aria-expanded", "true");
      $('ul.itg_pro_tab_head li[data-id="' + dataId + '"]').addClass("active");

      var targetTop = $part.offset().top - headerOffset - 10;
      window.scrollTo({ top: targetTop, behavior: "smooth" });
    } else {
      // On close, scroll to the top of the whole accordion section so all
      // accordion items remain visible (otherwise collapsing the last item
      // lets the browser clamp scroll toward the footer).
      var $section = $head.closest(".itg_pro_tab");
      if ($section.length) {
        var targetTop = $section.offset().top - headerOffset - 10;
        window.scrollTo({ top: targetTop, behavior: "smooth" });
      }
    }
  });


  $(document).on("click", ".itg_customize_btn button", function () {
    $(".itg_customize_open").toggleClass("active");
    $(".itg_ctm_pro_addtocart").toggleClass("hide");
    $(this).toggleClass("active");
    $(".itg_ctm_addtocart .product-form__buttons").toggleClass("itg_checked_class");
    $(".itg_product_variant").toggleClass("active");
    //$('.itg_ctm_product_page .itg_ctm_variant fieldset.js.product-form__input input').click();
  });

  $(document).on("click", ".itg_customize_btn button.active", function() {
    const productFormOptions = $('.itg_ctm_product_page .itg_mainmain_variant fieldset.js.product-form__input input');
    if(productFormOptions){
      productFormOptions.trigger('click');
    }
  });

  $(document).on("change", "select.itg_ctm_adapter_model", function () {
    var $option = $(this).find("option:selected").attr("data-variant-img");
    // console.log('check model')
    $(".itg_ctm_shaft_model img").attr("src", $option);
    $(".itg_ctm_shaft_model img").each(function () {
      if ($(this).attr("src") === "" || $(this).attr("src") === undefined) {
        $(this).removeClass("src");
      } else {
        $(this).addClass("src");
      }
    });
  });

  $(document).on("change", "select.itg_ctm_grip_model", function () {
    var $option = $(this).find("option:selected").attr("data-variant-img");
    $(".itg_ctm_grip_model img").attr("src", $option);
    $(".itg_ctm_grip_model img").each(function () {
      if ($(this).attr("src") === "" || $(this).attr("src") === undefined) {
        $(this).removeClass("src");
      } else {
        $(this).addClass("src");
      }
    });
  });

  $(document).on("change", "select.itg_ctm_ctm_ferrule", function () {
    var $option = $(this).find("option:selected").attr("data-variant-img");
    var selectedTitle = $(this).find("option:selected").attr("data-title");
    var selectedPrice = $(this).find("option:selected").attr("data-variant-price"); 
      $(".itg_ctm_ctm_ferrule_image img").attr("src", $option); 
      $(".itg_ctm_ctm_ferrule_image .itg_shaft_option_title").text(selectedTitle);
    if(!selectedPrice){
       $(".itg_ctm_ctm_ferrule_image .itg_shaft_option_price").addClass('hide');
    }else{
      $(".itg_ctm_ctm_ferrule_image .itg_shaft_option_price").text(selectedPrice);
      $(".itg_ctm_ctm_ferrule_image .itg_shaft_option_price").removeClass('hide');
    } 
    $(".itg_ctm_ctm_ferrule_image img").each(function () {
      if ($(this).attr("src") === "" || $(this).attr("src") === undefined) {
        $(this).removeClass("src");
      } else {
        $(this).addClass("src");
      }
    });
  });
  $(document).on('change','.itg_ctm_shaftmodel_part_ferrule_model input',function(){
      window.ferruleUserChanged = true;
    var selectedVal = $(this).val();
    var selectedImg = $(this).attr('data-variant-img');
    var selectedTitle = $(this).attr('data-title');
    var selectedPrice = $(this).attr('data-variant-price');
    const error_text = document.querySelector('.itg_lie_images_gallery.itg_customize_flex span.itg-error-text');
    //console.log(selectedVal,'selectedVal');
    $(".itg_ctm_ctm_ferrule").val(selectedVal).prop(true);
    if(selectedImg){
      $('.itg_customize_full.itg_ctm_ctm_ferrule_image').removeClass('Red_color');
      $('.itg_customize_full.itg_ctm_ctm_ferrule_image img').attr('src',selectedImg);
      $('.itg_customize_full.itg_ctm_ctm_ferrule_image img').addClass('src');
      error_text.classList.add('hide');
    }else{
      $('.itg_customize_full.itg_ctm_ctm_ferrule_image').addClass('Red_color');
      error_text.classList.remove('hide');
    }
    if(selectedTitle){
      $('.itg_customize_full.itg_ctm_ctm_ferrule_image .itg_shaft_option_title').text(selectedTitle);
    }
    if(selectedPrice){
      $('.itg_customize_full.itg_ctm_ctm_ferrule_image .itg_shaft_option_price').text(selectedPrice);
    }  
    setTimeout(function(){
      updateButtonState();
    }, 100);
  });

  function formatCurrency(cents, format) {
    var value = (cents / 100).toFixed(2);
    return format.replace("{{amount}}", value);
  }

  var main_price = parseInt(
    $("select.SwymGrAddOnProducts")
      .closest(
        ".shaft_product_customize,.product_customize,.Iron_club_product_customize"
      )
      .find(".price__regular")
      .attr("data-main-price")
  );
  var total_price = main_price;
  $("select.SwymGrAddOnProducts").each(function () {
    var var_price = parseInt(
      $(this).find("option:selected").attr("data-variant-price")
    );
    if (!isNaN(var_price)) {
      total_price += var_price;
    }
  });
  var currencyFormat = "${{amount}}";
  var formattedPrice = formatCurrency(total_price, currencyFormat);
  $("select.SwymGrAddOnProducts")
    .closest(
      ".shaft_product_customize,.product_customize,.Iron_club_product_customize"
    )
    .find(".price span.price-item")
    .text(formattedPrice);

  $(document).on("change", "select.SwymGrAddOnProducts", function () {
    var main_price = parseInt(
      $(this)
        .closest(
          ".shaft_product_customize,.product_customize,.Iron_club_product_customize, .itg_ctm_product_page"
        )
        .find(".price__regular")
        .attr("data-main-price")
    );
    var total_price = main_price;
    $("select.SwymGrAddOnProducts").each(function () {
      var var_price = parseInt(
        $(this).find("option:selected").attr("data-variant-price")
      );
      if (!isNaN(var_price)) {
        total_price += var_price;
      }
    });
    var currencyFormat = "${{amount}}";
    var formattedPrice = formatCurrency(total_price, currencyFormat);
    $(this)
      .closest(
        ".shaft_product_customize,.product_customize,.Iron_club_product_customize, .itg_ctm_product_page"
      )
      .find(".price span.price-item")
      .text(formattedPrice);
  });

  $(".itg_ctm_addtocart").on("click", function () {
    $(this)
      .closest(".itg_customize_open")
      .find(".itg_customize_step_part.active")
      .trigger("click");
  });

  $(".itg_customize_footer").on("click", function (e) {
    if ($(this).hasClass("soldout_variant")) {
      e.preventDefault(); // Click action rokne ke liye
      return false;
    } else {
      $(this)
        .closest(".itg_customize_open")
        .find(".itg_customize_step_part.active")
        .next()
        .trigger("click");
    }
  });

  /*----------------------------- NEW CODE START------------------------*/

  $(document).on("click", ".itg_customize_step_part", function () {
    $(".itg_customize_step_part").removeClass("active");
    $(this).addClass("active");
    var a = $(this).attr("data-step-id");

    $(".itg_main_step, .itg_customize_footer").each(function () {
      var b = $(this).attr("data-step-id") || $(this).attr("data-footer-id");
      if (a == b) {
        $(this).fadeIn(200).addClass("active custom-fade");
        $('html, body').animate({
          scrollTop: $('#itg_custom_options').offset().top
        }, 200); 
      } else {
        $(this).fadeOut(200, function () {
          $(this).removeClass("active custom-fade").css("display", "none");
        });
      }
    });
  });

  // function validateBusinessCheckbox() {
  //   var checkboxChecked = $("input#Business").is(":checked");
  //   if (checkboxChecked) {
  //     $(".itg_ctm_addtocart .product-form__buttons").removeClass(
  //       "itg_checked_class"
  //     );
  //     $("input#Business").removeClass("red_color");
  //   } else {
  //     $(".itg_ctm_addtocart .product-form__buttons").addClass(
  //       "itg_checked_class"
  //     );
  //     $("input#Business").addClass("red_color");
  //   }
  // }

  $(document).on("click", ".itg_checked_class", function () {
    // console.log('asd')
    var steps = $(".itg_main_step");
    var stepFound = false;

    steps.each(function () {
      var step = $(this);
      var selectFound = false;

      step.find("select").each(function () {
        if ($(this).val().trim() === "") {
          //$(this).addClass("Red_color");
          selectFound = true;
        } else {
          //$(this).removeClass("Red_color");
        }
      }); 
      // console.log(selectFound,'selectFound');
      if (selectFound) {
        stepFound = true;
        const currentStep = step.attr("data-step-id").trim();
        //console.log(currentStep,'currentStep');
      
        $(".itg_customize_step_part").removeClass("active");
        $('.itg_customize_step_part[data-step-id="' +step.attr("data-step-id")+'"]').addClass("active");
        setTimeout(() => {
          //console.log(currentStep,'currentStep');
          $(`.itg_customize_footer[data-footer-id="${currentStep}"]`).addClass("active");
        }, 100);

        $(".itg_main_step, .itg_customize_footer").each(function () {
          var b = $(this).attr("data-step-id") || $(this).attr("data-footer-id");
          
          if (b == step.attr("data-step-id")) {
            $(this).fadeIn(200).addClass("active custom-fade");
          } else {
            $(this).fadeOut(200, function () {
              $(this).removeClass("active custom-fade").css("display", "none");
            });
          }
        });

        return false; // Stop loop if we find a blank select
      }
    });

    if (!stepFound) {
      validateBusinessCheckbox();
    }
  });

  $("input#Business").change(function () {
    validateBusinessCheckbox();
  });

  /*----------------------------- NEW CODE END------------------------*/

  $(".product_customize input#Business").change(function () {
    let checkboxChecked = $(this).is(":checked");
    if (checkboxChecked) {
      $(
        ".product_customize .itg_ctm_addtocart .product-form__buttons"
      ).removeClass("itg_checked_class");
      $(".product_customize input#Business").removeClass("red_color");
    } else {
      $(
        ".product_customize .itg_ctm_addtocart .product-form__buttons"
      ).addClass("itg_checked_class");
      if (!checkboxChecked) {
        $(".product_customize input#Business").addClass("red_color");
      }
    }
  });

  $(document).on("click", function () {
    $(".shaft_product_customize").find(".itg_lie_popup").removeClass("active");
  });

  $(document).on("click", ".itg_lie_spece", function (e) {
    $(".itg_lie_popup").addClass("active");
    e.stopPropagation();
  });
  $(document).on("click", ".itg_lie_close_icon", function () {
    $(".itg_lie_popup").removeClass("active");
  });

  $(document).on("click", function () {
    $(
      ".putter-shafts,.wedge-shafts,.driving-ironIron-shafts,.shaft_product_customize,.driving-irons,.Irons,.wedges,.putters,.driverfairway-wood-shafts,.hybrid-shafts"
    )
      .find(".itg_loft_popup,.itg_lie_popup")
      .removeClass("active");
  });

  $(document).on("click", ".itg_loft_spece", function (e) {
    $(".itg_loft_popup").addClass("active");
    e.stopPropagation();
  });
  $(document).on("click", ".itg_loft_close_icon", function () {
    $(".itg_loft_popup").removeClass("active");
  });

  $(document).on("click", ".itg_accordion_qus", function () {
    var $this = $(this);
    if ($this.hasClass("active")) {
      $this.removeClass("active");
      $this
        .closest(".itg_accordion_main")
        .find(".itg_accordion_ans")
        .removeClass("active");
    } else {
      $(".itg_accordion_qus").removeClass("active");
      $this.addClass("active");
      $(".itg_accordion_ans").removeClass("active");
      $this
        .closest(".itg_accordion_main")
        .find(".itg_accordion_ans")
        .addClass("active");
    }
  });

  $(document).on("click", ".itg_ctm_quantity .quantity__button", function () {
    var getQty = $(this)
      .closest(".itg_ctm_quantity")
      .find(".quantity__input")
      .val();
    if (getQty) {
      $(document).find(".product-variant-qty").val(getQty);
    }
  });

  $(document).on(
    "keyup change keypress",
    ".itg_ctm_quantity .quantity__input",
    function () {
      var getQty = $(this)
        .closest(".itg_ctm_quantity")
        .find(".quantity__input")
        .val();
      if (getQty) {
        $(document).find(".product-variant-qty").val(getQty);
      }
    }
  );
});

$(document).ready(function () {
  $('a[href^="#"]').on("click", function (event) {
    event.preventDefault();
    var targetId = this.hash;
    var $target = $(targetId);
    $("html, body").animate(
      {
        scrollTop: $target.offset().top - 100,
      },
      800
    );
  });

  $(document).ready(function () {
    //$(".itg_customize_flex .itg_shaft_flexpart:first-child").trigger("click");
  });

  $(".itg_customize_flex select.itg_shaft_change").change(function () {
    // console.log('ass');
    var a = $(this).find(":selected").attr("data-vendor");
    var val = $(this).val();
    var firstOption = $(
      ".itg_customize_flex select.itg_custom_change_value option:first-child"
    );
    if(val){
      $(this).removeClass('Red_color');
      $(this).closest('.itg_customize_full').find('.itg-error-text').addClass('hide');
    }else{
      $(this).addClass('Red_color');
      $(this).closest('.itg_customize_full').find('.itg-error-text').removeClass('hide');
    }
    if(firstOption) firstOption.css("display", "block");
    if(suffix == 'custom-driver-fairway-woo' || suffix == 'custom-iron-wedge-shaft' || suffix == 'parallel-custom-iron-wedg'){}else{
      $(".itg_customize_flex select.itg_shaft_change_value option").each(function () {
        var b = $(this).attr("data-vendor");
        if (a == b || $(this).is(firstOption)) {
          $(this).css("display", "block");
        } else {
          $(this).css("display", "none");
        }
      });
    }
    // $('.itg_ctm_flexmodel .itg_ctm_shaftmodel_part.active').each(function(){
    //   var shaftVendor = $(this).find('input').attr('data-vendor')
    //   if (shaftVendor == a){
    //     $(this).addClass('talk')
    //   }
    //   else{
    //     $(this).removeClass('talk')
    //   }
    // })
    // $(".itg_customize_flex select.itg_shaft_change")
    //   .not(this)
    //   .val($(this).val())
    //   .trigger("change");
    // Sync sibling shaft-brand selects; trigger only when the value actually
    // changes — an unconditional trigger makes the selects re-trigger each
    // other infinitely (Maximum call stack size exceeded).
    var itgSyncVal = $(this).val();
    $(".itg_customize_flex select.itg_shaft_change").not(this).each(function () {
      if ($(this).val() !== itgSyncVal) {
        $(this).val(itgSyncVal).trigger("change");
      }
    });
  });

  $(".itg_customize_flex select.itg_grip_change").change(function () {  
    var a = $(this).find(":selected").attr("data-vendor");   
    var grip_model_selector = $(".itg_ctm_flexmodel.grip_model .itg_ctm_shaftmodel_part_grip_model");
    var gripVal = $(this).val();
    if(!gripVal){
      $('.grip_brand span.itg-error-text').removeClass('hide');
      $('.itg_customize_flex select.itg_grip_change').addClass('Red_color');   
    }else{
      setTimeout(function(){
        //$('.itg_ctm_shaftmodel_part_grip_model:not(.hide) label.itg_ctm_shaftmodel_label').first().trigger('click');
      },100);  
      $('.grip_brand span.itg-error-text').addClass('hide');
      $('.itg_customize_flex select.itg_grip_change').removeClass('Red_color'); 
     
    }
    if(suffix == 'new-custom-taper-tip-iron' || suffix == 'custom-taylormade-putters' || suffix == 'new-custom-parallel-iron' || suffix == 'custom-driver-fairway-woo' || suffix == 'custom-iron-wedge-shaft' || suffix == 'parallel-custom-iron-wedg' || suffix == 'new-custom-driver-fairway' || suffix == 'custom-driver-fw-hy' || suffix == 'custom-driver-fa' || suffix == 'irons-sell-as-set'){
      let firstOption = $(".itg_customize_flex select.itg_grip_change_value option:first-child");
      let imgSrc = $('.itg_customize_full.itg_ctm_grip_model img').attr('src');
      $(".itg_customize_flex select.itg_grip_change_value").val(firstOption.val());
      if(!imgSrc){
        $('.itg_customize_full.itg_ctm_grip_model img').removeClass('src'); 
      }
      $(".itg_customize_flex select.itg_grip_change option[data-vendor="+ a +"]").prop("selected", true);
       $('.itg_ctm_shaft_grip_gallery.itg_customize_flex').removeClass('itg_disabled');
      if(grip_model_selector){
        grip_model_selector.each(function(){
          var grip_model_selector_brand =  $(this).attr("data-brand");
          //console.log(grip_model_selector_brand,'grip_model_selector_brand',a)
          if(grip_model_selector_brand == a){
            $(this).removeClass('hide');
            var selectGripBoxHtml = $(".itg_ctm_shaftmodel_part_grip_model:not(.hide)").find(".itg_select_box").html();
            $(".itg_customize_full.itg_ctm_grip_model").html(selectGripBoxHtml);    
            //console.log(a,'html',selectGripBoxHtml);
            const $select = $('select.SwymGrAddOnProducts[name="properties[Grip Model]"]');
            if($select) $select.find('option[data-vendor="'+a+'"]').first().prop('selected', true);
          }else{
            $(this).addClass('hide');
          }
        });
      }

    }else{  
      var firstOption = $(
        ".itg_customize_flex select.itg_custom_change_value option:first-child"
      );
    }  
    
    if(firstOption) firstOption.css("display", "block");
   
    $(".itg_customize_flex select.itg_grip_change_value option").each(
      function () {
        var b = $(this).attr("data-vendor");     
        if (a == b || $(this).is(firstOption)) {         
          $(this).css("display", "block");
        } else {
          $(this).css("display", "none");
        }
      }
    );
  });

  $(document).on('change','.itg_ctm_flexmodel.grip_model .itg_ctm_shaftmodel_part_grip_model input',function(){
    window.gripUserChanged = true;
    var selectedVal = $(this).val();
    var selectedImg = $(this).attr('data-variant-img');
    var selectedTitle = $(this).attr('data-title');
    var selectedPrice = $(this).attr('data-variant-price');
    var selectedGripVendor = $(this).attr('data-vendor');

    const error_text = document.querySelector('.itg_ctm_shaft_grip_gallery.itg_customize_flex .itg-error-text');
    //console.log(selectedVal,'selectedVal');
    // $("select.itg_ctm_grip_model").val(selectedVal).prop(true);
    $("select.itg_ctm_grip_model").val(selectedVal).trigger('change');
    if (selectedGripVendor) {
      $("select[name='properties[Grip Brand]']").each(function () {
        var sel = this;
        var matchOpt = sel.querySelector('option[data-vendor="' + selectedGripVendor + '"]');
        if (matchOpt) {
          Array.from(sel.options).forEach(function (o) { o.selected = false; });
          matchOpt.selected = true;
          sel.classList.remove('Red_color');
          var gripBrandError = sel.closest('.grip_brand');
          if (gripBrandError) {
            var errEl = gripBrandError.querySelector('.itg-error-text');
            if (errEl) errEl.classList.add('hide');
          }
        }
      });
    }

    if(selectedImg){
      $('.itg_customize_full.itg_ctm_grip_model').removeClass('Red_color');
      $('.itg_customize_full.itg_ctm_grip_model img').attr('src',selectedImg);
      $('.itg_customize_full.itg_ctm_grip_model img').addClass('src');
      error_text.classList.add('hide');
    }else{
      $('.itg_customize_full.itg_ctm_grip_model').addClass('Red_color');
      error_text.classList.remove('hide');
    }
    if(selectedTitle){
      $('.itg_customize_full.itg_ctm_grip_model .itg_shaft_option_title').text(selectedTitle);
    }
    if(selectedPrice){
      $('.itg_customize_full.itg_ctm_grip_model .itg_shaft_option_price').text(selectedPrice);
    }
    setTimeout(function(){
      updateButtonState();
    }, 100);
  }); 


  // var productData = JSON.parse($('script[type="application/json"][data-selected-variant]').text());
  // var productId = productData.id;
  // $('select.itg_ctm_change_option option').each(function() {
  //   var variantid = $(this).attr('data-varaint-id');
  //   if(productId == variantid){
  //     var metafiled_id = $(this).attr('data-variant-metafield');
  //     $('.itg_selected_id').val(metafiled_id);
  //   }
  // });

  // $(document).on("change", ".itg_metafiled_val_get", function() {
  //   console.log('selected=====',$('.itg_metafiled_val_get :selected').length);
  //   let values = [];
  //   console.log("Values---",values);
  //   var productId = $(this).find(':selected').attr('data-variant-metafield');
  //   var currentValue = $('.itg_selected_id').val();
  //   var selectId = $(this).attr('id');
  //   values = currentValue ? currentValue.split(',').map(item => item.trim()) : [];
  //   if (!values.includes(productId)) {
  //     values.push(productId);
  //   }
  //   $('.itg_selected_id').val(values.join(', '));
  // });

  // ----------------- Modified Code ----------------
  let values = [];
  $(document).on("change", ".itg_metafiled_val_get", function () {
    let stepIndex = $(".itg_metafiled_val_get").index(this);
    let selectedOption = $(this).find(":selected");
    let productId = selectedOption.attr("data-variant-metafield");
   // console.log(productId,'productId')
    values[stepIndex] = productId ? productId : null;
    $(".itg_selected_id").val(values.filter(Boolean).join(", "));
    let variantTitle = $(this).find(':selected').data('title');
    let ctm_grip_model_selector = 'select.itg_ctm_grip_model option';
    let ctm_ferrule_selector = 'select.itg_ctm_ctm_ferrule option';
    if(variantTitle && ctm_grip_model_selector || ctm_ferrule_selector) {
      $(document).find(`${ctm_grip_model_selector}[data-title="${variantTitle}"], ${ctm_ferrule_selector}[data-title="${variantTitle}"]`).prop('selected',true);
    }  
  });

  // $(document).on(
  //   "change",
  //   ".itg_ctm_product_page fieldset.js.product-form__input input",
  //   function () {
  //     setTimeout(function () {
  //       var isDisabled = $(
  //         ".itg_customize_footer.itg_ctm_addtocart button.product-form__submit"
  //       ).prop("disabled");
  //       if (isDisabled) {
  //         $(".itg_main_addtocart .product-form__buttons button")
  //           .text("Sold Out")
  //           .prop("disabled", true);
  //         // $('.itg_ctm_product_page fieldset.js.product-form__input input').addClass("disabled");
  //       } else {
  //         $(".itg_main_addtocart .product-form__buttons button")
  //           .text("Add to Cart")
  //           .prop("disabled", false);
  //         // $('.itg_ctm_product_page fieldset.js.product-form__input input').removeClass("disabled");
  //       }
  //     }, 1500);
  //   }
  // );

  // var currentUrl = window.location.href;

  // if (currentUrl.includes('collections')) {
  //   $('li.itg_In_stock input[type="checkbox"]').trigger('click');
  // }

  var currentUrl = window.location.href;
  if (currentUrl.includes("collections")) {
    if (currentUrl.includes("&filter.v.availability=1")) {
      //$('body').addClass('itg_qty_hide');
    } else {
      $("body").addClass("itg_qty_hide");
      var checkbox = $('li.itg_In_stock input[type="checkbox"]');
      if (!checkbox.prop("checked")) {
        $('li.itg_In_stock input[type="checkbox"]').trigger("click");
        checkbox.prop("checked", true);
      } else {
        // alert('no');
        checkbox.prop("checked", false);
      }
    }
  }

  $(document).on("click", "a.active-facets__button-remove", function () {
    setTimeout(function () {
      var currentUrl = window.location.href;
      if (currentUrl.includes("collections")) {
        if (currentUrl.includes("&filter.v.availability=1")) {
        } else {
          $('li.itg_In_stock input[type="checkbox"]').trigger("click");
        }
      }
    }, 1000);
  });

  $(document).on(
    "click",
    ".itg_ctm_pro_addtocart .quantity__button",
    function () {
      // alert('yes');
      var QTY = $(".itg_ctm_pro_addtocart .quantity__input").val();
      $(".itg_main_addtocart .SwymGrQtyMain").val(QTY);
    }
  );

  $(document).on(
    "click",
    ".itg_customize_footer .quantity__button",
    function () {
      var QTY2 = $(".itg_customize_footer .quantity__input").val();
      $(".itg_customize_footer .SwymGrQtyMain").val(QTY2);
    }
  );

  $(document).on("click", ".itg_shaftChoices, .itg_ctm_shaft_grip_gallery.itg_customize_flex .itg_ctm_grip_model, .itg_customize_full.itg_ctm_ctm_ferrule_image", function () {
    $(".itg_shaft_sidebar").addClass("active");
    $("body").addClass("itg_open_cc");
  });
  $(document).on("click", ".shaftSearch", function () {
    $(".itg_shaft_sidebar.search").addClass("active");
    $("body").addClass("itg_open_cc");
  });
  $(document).on(
    "click",
    "body.itg_open_cc .click-capture,.itg_closeContainer,.itg_shaft_sidebar input[type=radio]:checked",
    function () {
      $(".itg_shaft_sidebar").removeClass("active");
      $("body").removeClass("itg_open_cc");
      //document.querySelector('input#searchInput').value = '';
    }
  );
  var suffix = document.querySelector('body').getAttribute('data-template');
  if(suffix == 'new-custom-taper-tip-iron'  || suffix == 'custom-taylormade-putters'  || suffix == 'new-custom-parallel-iron' || suffix == 'custom-driver-fairway-woo' || suffix == 'custom-iron-wedge-shaft' || suffix == 'parallel-custom-iron-wedg' || suffix == 'new-custom-driver-fairway' || suffix == 'custom-driver-fw-hy' || suffix == 'custom-driver-fa' || suffix == 'irons-sell-as-set'){    
    var shaft_material = document.querySelector('select[name="properties[Shaft Material]"]');
    var shaft_brands = document.querySelectorAll('select[name="properties[Shaft Brand]"]');
    var flex_parts = document.querySelectorAll('.itg_shaft_flexpart');
    var combination = document.querySelectorAll('.itg_ctm_shaftmodel_part');
    var shaftChoices = document.querySelector(".itg_shaftChoices");
    function normalize(val) {
      return val ? val.trim().toLowerCase().replace(/[\s_]+/g, '') : '';
    }
    // Point every Shaft Brand select at the vendor of the first available shaft card
    // passing `matches`; returns the chosen brand value ('' if none found).
    function autoSelectFirstBrand(matches) {
      var chosen = '';
      var firstCard = Array.from(combination).find(function (combine) {
        return combine.classList.contains('available') && matches(combine);
      });
      var firstInput = firstCard ? firstCard.querySelector('input') : null;
      var firstVendor = firstInput ? firstInput.getAttribute('data-vendor') : null;
      if (!firstVendor) return chosen;
      shaft_brands.forEach(function (brandSelect) {
        var matchOpt = brandSelect.querySelector('option[data-vendor="' + firstVendor + '"]');
        if (matchOpt) {
          Array.from(brandSelect.options).forEach(function (o) { o.selected = false; });
          matchOpt.selected = true;
          brandSelect.classList.remove('Red_color');
          chosen = matchOpt.value;
        }
      });
      return chosen;
    }

    if (shaft_material && shaft_brands && flex_parts) {
      function updateFlexPartsVisibility() {
        var shaft_material_val = shaft_material.value;
       
        flex_parts.forEach(flex_part => flex_part.style.display = 'none');
        combination.forEach(function (combine) {
          var combine_shaft_material = combine.getAttribute('data-shaft-material');
          var combine_brand_val = combine.getAttribute('data-brand');
          var combine_flex_val = combine.getAttribute('data-attr-tag');
          
            if (
              (!shaft_material_val || normalize(shaft_material_val) == normalize(combine_shaft_material))  
            ) {
            
              flex_parts.forEach(function (flex_part) {   
                var flexVal = flex_part.getAttribute('data-shaft-val')
                
                if (normalize(flexVal) == normalize(combine_flex_val)) {                          
                  flex_part.style.display = 'inline-block';
                }
              });
            }else{
              //console.log('error')
            }
             
        });
      }

      function updateBrandOptions() {
        var shaft_material_val = shaft_material.value;
        var activeFlex = document.querySelector('.itg_shaft_flexpart.active');
        var flex_val = activeFlex ? activeFlex.getAttribute('data-shaft-val') : '';

        var valid_brands = new Set();

        combination.forEach(function (combine) {
          var combine_shaft_material = combine.getAttribute('data-shaft-material');
          var combine_brand_val = combine.getAttribute('data-brand');
          var combine_flex_val = combine.getAttribute('data-attr-tag');

          var shaft_material_match = !shaft_material_val || normalize(shaft_material_val) === normalize(combine_shaft_material);
          var flex_match = !flex_val || normalize(flex_val) === normalize(combine_flex_val);

          if (shaft_material_match && flex_match) {
            valid_brands.add(normalize(combine_brand_val));
          }
        });

        shaft_brands.forEach(function (brandSelect) {
          var options = brandSelect.querySelectorAll('option');

          options.forEach(function (opt) {
            if (opt.value === "") return;
            if (valid_brands.has(normalize(opt.value))) {
              opt.style.display = 'block';
              opt.disabled = false;
            } else {
              opt.style.display = 'none';
              opt.disabled = true;
              if (opt.selected) brandSelect.value = "";
            }
          });
        });
      }
 
      function filterCombinations(flex_) {
        var shaft_material_val = shaft_material.value;
        var shaft_brand_val = '';
        shaft_brands.forEach(function (brandSelect) {
          if (brandSelect.value) shaft_brand_val = brandSelect.value;
        });

        if (shaft_material_val) {
          shaftChoices.classList.remove('hide');
        } else {
          shaftChoices.classList.add('hide');
        }

        var flex_val = '';
        if (flex_) {
          flex_parts.forEach(el => el.classList.remove('active'));
          flex_.classList.add('active');
        }

        var activeFlex = document.querySelector('.itg_shaft_flexpart.active');
        if (activeFlex) {
          flex_val = activeFlex.getAttribute('data-shaft-val');
          flex_parts.forEach(function (flex_part) {
            var match_value = flex_part.getAttribute('data-shaft-val');
            flex_part.classList.toggle('active', normalize(match_value) === normalize(flex_val));
          });
        }

        // No brand picked yet: auto-select the first available matching shaft's vendor
        // before filtering, so the Model list only shows that brand's shafts.
        if (!shaft_brand_val) {
          shaft_brand_val = autoSelectFirstBrand(function (combine) {
            var matMatch = !shaft_material_val || normalize(shaft_material_val) === normalize(combine.getAttribute('data-shaft-material'));
            var flexMatch = !flex_val || normalize(flex_val) === normalize(combine.getAttribute('data-attr-tag'));
            return matMatch && flexMatch;
          });
        }

        shaftChoices.innerHTML = '';
        let count = 0
        combination.forEach(function (combine,index) {
          
          var combine_shaft_material = combine.getAttribute('data-shaft-material');
          var combine_brand_val = combine.getAttribute('data-brand');
          var combine_flex_val = combine.getAttribute('data-attr-tag');

          var shaft_material_match = !shaft_material_val || normalize(shaft_material_val) === normalize(combine_shaft_material);
          var brand_match = !shaft_brand_val || normalize(shaft_brand_val) === normalize(combine_brand_val);
          var flex_match = !flex_val || normalize(flex_val) === normalize(combine_flex_val);
           
            //console.log(shaft_material_val +'&&'+ shaft_brand_val +'&&'+ flex_val);
            if (shaft_material_match && brand_match && flex_match) {
              combine.style.display = 'block';
              combine.classList.add('active');
              if(combine.classList.contains('available')){          
                if(count == 0) {
                  let selectBox = combine.querySelector(".itg_select_box");
                  let selectVariant= selectBox.querySelector('img').getAttribute('variant_id');
                  //console.log(selectVariant,'selectVariant');
                  if (selectBox) {
                    shaftChoices.innerHTML += selectBox.innerHTML;
                    document.querySelector("select.itg_shaft_change_value.SwymGrAddOnProducts[name='properties[Shaft Model]']").value = selectVariant
                    // console.log(selectBox.innerHTML,'html',selectVariant);
                  }          
                }
                count++;
              }  
            } else {
              combine.style.display = 'none';
              combine.classList.remove('active');
            }  

        });
        updateFlexPartsVisibility();
        updateBrandOptions();
       
      }

      shaft_material.addEventListener('change', function () {
        flex_parts.forEach(el => el.classList.remove('active'));
        shaft_brands.forEach(function (bs) { bs.value = ""; });
        filterCombinations();
      });

      shaft_brands.forEach(function (brandSelect) {
        brandSelect.addEventListener('change', function () {
          filterCombinations();
        });
      });

      flex_parts.forEach(function (flexEl) {
        flexEl.addEventListener('click', function () {
          // shaft_brands.forEach(function (bs) { bs.value = ""; });
          // Keep the selected brand if it still has models for the newly chosen flex;
          // otherwise fall back to clearing (which auto-selects the first matching card's brand).
          var newFlexVal = this.getAttribute('data-shaft-val');
          var currentBrand = '';
          shaft_brands.forEach(function (bs) { if (bs.value) currentBrand = bs.value; });
          var brandStillValid = false;
          if (currentBrand) {
            var shaft_material_val = shaft_material.value;
            combination.forEach(function (combine) {
              var cMat = combine.getAttribute('data-shaft-material');
              var cBrand = combine.getAttribute('data-brand');
              var cFlex = combine.getAttribute('data-attr-tag');
              var matMatch = !shaft_material_val || normalize(shaft_material_val) === normalize(cMat);
              if (matMatch && normalize(cBrand) === normalize(currentBrand) && normalize(cFlex) === normalize(newFlexVal)) {
                brandStillValid = true;
              }
            });
          }
          if (!brandStillValid) {
            shaft_brands.forEach(function (bs) { bs.value = ""; });
          }
          filterCombinations(this);
        });
      });

    }else if(flex_parts && shaft_brands){
      function updateFlexPartsVisibility() {
        var shaft_brand_val = '';
        shaft_brands.forEach(function (brandSelect) {
          if (brandSelect.value) shaft_brand_val = brandSelect.value;
        });

        flex_parts.forEach(flex_part => flex_part.style.display = 'none');

        combination.forEach(function (combine) {
          var combine_brand_val = combine.getAttribute('data-brand');
          var combine_flex_val = combine.getAttribute('data-attr-tag');

          if (!shaft_brand_val || normalize(shaft_brand_val) === normalize(combine_brand_val)) {
            flex_parts.forEach(function (flex_part) {
              if (normalize(flex_part.getAttribute('data-shaft-val')) === normalize(combine_flex_val)) {
                flex_part.style.display = 'inline-block';
              }
            });
          }
        });
      }

      function updateBrandOptions() {
        var activeFlex = document.querySelector('.itg_shaft_flexpart.active');
        var flex_val = activeFlex ? activeFlex.getAttribute('data-shaft-val') : '';

        var valid_brands = new Set();

        combination.forEach(function (combine) {
          var combine_brand_val = combine.getAttribute('data-brand');
          var combine_flex_val = combine.getAttribute('data-attr-tag');

          var flex_match = !flex_val || normalize(flex_val) === normalize(combine_flex_val);

          if (flex_match) {
            valid_brands.add(normalize(combine_brand_val));
          }
        });

        shaft_brands.forEach(function (brandSelect) {
          var options = brandSelect.querySelectorAll('option');

          options.forEach(function (opt) {
            if (opt.value === "") return;
            if (valid_brands.has(normalize(opt.value))) {
              opt.style.display = 'block';
              opt.disabled = false;
            } else {
              opt.style.display = 'none';
              opt.disabled = true;
              if (opt.selected) brandSelect.value = "";
            }
          });
        });
      }

      function filterCombinations(flex_) {
        var shaft_brand_val = '';
        shaft_brands.forEach(function (brandSelect) {
          if (brandSelect.value) shaft_brand_val = brandSelect.value;
        });

        var flex_val = '';
        if (flex_) {
          flex_parts.forEach(el => el.classList.remove('active'));
          flex_.classList.add('active');
        }

        var activeFlex = document.querySelector('.itg_shaft_flexpart.active');
        if (activeFlex) {
          flex_val = activeFlex.getAttribute('data-shaft-val');
          flex_parts.forEach(function (flex_part) {
            var match_value = flex_part.getAttribute('data-shaft-val');
            flex_part.classList.toggle('active', normalize(match_value) === normalize(flex_val));
          });
        }

        // No brand picked yet: auto-select the first available matching shaft's vendor
        // before filtering, so the Model list only shows that brand's shafts.
        if (!shaft_brand_val) {
          shaft_brand_val = autoSelectFirstBrand(function (combine) {
            return !flex_val || normalize(flex_val) === normalize(combine.getAttribute('data-attr-tag'));
          });
        }

        if (shaft_brand_val || flex_val) {
          shaftChoices.classList.remove('hide');
        } else {
          shaftChoices.classList.add('hide');
        }

        shaftChoices.innerHTML = '';
        let count = 0;
        combination.forEach(function (combine) {
          var combine_brand_val = combine.getAttribute('data-brand');
          var combine_flex_val = combine.getAttribute('data-attr-tag');

          var brand_match = !shaft_brand_val || normalize(shaft_brand_val) === normalize(combine_brand_val);
          var flex_match = !flex_val || normalize(flex_val) === normalize(combine_flex_val);

          if (brand_match && flex_match) {            
              combine.style.display = 'block';
              combine.classList.add('active');
              if(combine.classList.contains('available')){          
                if(count == 0) {
                  let selectBox = combine.querySelector(".itg_select_box");
                  let selectVariant= selectBox.querySelector('img').getAttribute('variant_id');
                  if (selectBox) {
                    shaftChoices.innerHTML += selectBox.innerHTML;
                    document.querySelector("select.itg_shaft_change_value.SwymGrAddOnProducts[name='properties[Shaft Model]']").value = selectVariant
                    // console.log('shaftChoices')
                  }
                }
                count++; 
              }   
          } else {
            combine.style.display = 'none';
            combine.classList.remove('active');
          }
        });

        updateFlexPartsVisibility();
        updateBrandOptions();
      }

 
      shaft_brands.forEach(function (brandSelect) {
        brandSelect.addEventListener('change', function () {
          filterCombinations();
        });
      });

      flex_parts.forEach(function (flexEl) {
        flexEl.addEventListener('click', function () {
          //console.log('tjis')
          //shaft_brands.forEach(function (bs) { bs.value = ""; });
          // Keep the selected brand if it still has models for the newly chosen flex;
          // otherwise fall back to clearing (which auto-selects the first matching card's brand).
          var newFlexVal = this.getAttribute('data-shaft-val');
          var currentBrand = '';
          shaft_brands.forEach(function (bs) { if (bs.value) currentBrand = bs.value; });
          var brandStillValid = false;
          if (currentBrand) {
            combination.forEach(function (combine) {
              var cBrand = combine.getAttribute('data-brand');
              var cFlex = combine.getAttribute('data-attr-tag');
              if (normalize(cBrand) === normalize(currentBrand) && normalize(cFlex) === normalize(newFlexVal)) {
                brandStillValid = true;
              }
            });
          }
          if (!brandStillValid) {
            shaft_brands.forEach(function (bs) { bs.value = ""; });
          }
          filterCombinations(this);
        });
      });
    }
 
   }else {
    $(document).on("click", ".itg_shaft_flexpart", function () {
      // console.log('itg_shaft_flexpart');
      var tag_val = $(this).attr("data-shaft-val");
      $(".itg_shaft_flexpart").removeClass("active");
      $(this).addClass("active");
      let Option1 = $("select.itg_shaft_changees option:first-child");
      Option1.prop("selected", true);

      $("select.itg_shaft_changees option").each(function () {
        var attrTagValue = $(this).attr("data-shaft-tag");
        if (attrTagValue === tag_val) {
          $(this).css("display", "block");
          $(this).addClass("activeBrand");
        } else {
          $(this).css("display", "none");
          $(this).removeClass("activeBrand");
        }
      });
      // let activeOptions = $("select option.activeBrand");
      // let optionfirst =  activeOptions.first().attr("data-vendor");

      $(".itg_ctm_shaftmodel_part").each(function () {
        var attrTagValue = $(this).attr("data-attr-tag");
        if (attrTagValue === tag_val) {
          $(this).addClass("active");
          $(this).css("display", "block");
        } else {
          $(this).css("display", "none");
          $(this).removeClass("active");
        }
      });

      var a = $(".itg_shaft_flexpart.active").attr("data-shaft-val");
      $(".itg_shaft_flexpart").each(function () {
        var b = $(this).attr("data-shaft-val");
        if (a == b) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });

      var selectBoxHtml = $(".itg_ctm_shaftmodel_part.active")
        .find(".itg_select_box")
        .html();
      
    
      $(".itg_shaftChoices").html(selectBoxHtml);
    
    });
  } 
  var selectBoxHtml = $(".itg_ctm_shaftmodel_part:first-child")
    .find(".itg_select_box")
    .html();
   var selectGripBoxHtml = $(".itg_ctm_shaftmodel_part_grip_model:first-child")
        .find(".itg_select_box")
        .html();
 
  $(".itg_shaftChoices").html(selectBoxHtml);

  $(".itg_customize_full.itg_ctm_grip_model").html(selectGripBoxHtml);
  
  // No shaft/grip brand or model is pre-selected: every selection must be made
  // by the customer (the boxes above are only seeded as click targets for the
  // picker sidebars — they do not set any form value).

  $(document).on("change", ".itg_ctm_shaftmodel_part input", function () {
    window.shaftUserChanged = true;
    var a = $(this).attr("data-id");
    // Keep the Shaft Brand dropdown in step with the picked shaft's vendor
    // (no change trigger, so the chosen model isn't re-filtered away).
    var selectedShaftVendor = $(this).attr("data-vendor");
    if (selectedShaftVendor) {
      $("select[name='properties[Shaft Brand]']").each(function () {
        var matchOpt = this.querySelector('option[data-vendor="' + selectedShaftVendor + '"]');
        if (matchOpt && this.value !== matchOpt.value) {
          this.value = matchOpt.value;
          this.classList.remove('Red_color');
        }
      });
    }
    if(suffix == 'custom-driver-fairway-woo' || suffix == 'custom-iron-wedge-shaft' || suffix == 'parallel-custom-iron-wedg'){
      $('.SwymGrAddOnProducts.itg_ctm_adapter_model').val(a).trigger('change');
    }
    var selectElement = $(".itg_model_none select");
    selectElement.find("option").each(function () {
      if ($(this).val() === a) {
        $(this).prop("selected", true);
      }
    });
    var selectBoxHtmlVariantId = $(this).closest(".itg_ctm_shaftmodel_part").find(".itg_select_box img").attr('variant_id');
    var selectBoxHtml = $(this)
      .closest(".itg_ctm_shaftmodel_part")
      .find(".itg_select_box")
      .html();
       
    $(".itg_shaftChoices").html(selectBoxHtml);
    $("select.SwymGrAddOnProducts[name='properties[Shaft Model]']").val(selectBoxHtmlVariantId).trigger('click');
    const adaptorSettings = document.querySelector('select.itg_ctm_length[name="properties[Adaptor Settings]"] option[data-val="Choose Option"]');
    if(adaptorSettings) adaptorSettings.selected = true;
    const adaptor_settings = document.querySelectorAll('select.itg_ctm_length[name="properties[Adaptor Settings]"] option.adaptor-settings');
    if (adaptor_settings.length > 0) {
      adaptor_settings.forEach(function (option) {
        const variantId = option.getAttribute('variantid');
        if (selectBoxHtmlVariantId === variantId) {
          option.classList.remove('hide');
        } else {
          option.classList.add('hide');
        }
      });
    }
    // console.log('afds',selectBoxHtmlVariantId)
    setTimeout(function(){
      updateButtonState();
    }, 100);
  });
});

function fillHidden(hiddenname) {
  var checkboxes = document.querySelectorAll(
    '[hidden-data="' + hiddenname + '"]'
  );
  var hiddenfield = document.getElementById(hiddenname);
  hiddenfield.value = "";
  var i;
  for (i = 0; i < checkboxes.length; i++) {
    var x = checkboxes[i];
    if (x.checked) {
      if (hiddenfield.value == "") {
        hiddenfield.value = x.value;
      } else {
        hiddenfield.value = hiddenfield.value + ", " + x.value;
      }
    }
  }
}
function setCheckboxesFromHidden() {
  var hiddenfield = document.getElementById("Club-Numbers");
  var selectedValues = hiddenfield.value.split(", ");
  selectedValues.forEach(function (value) {
    var checkbox = document.querySelector(
      'input[type="checkbox"][value="' + value + '"]'
    );
    if (checkbox) {
      checkbox.checked = true;
    }
  });
  fillHidden("Club-Numbers");
}

// window.onload = function() {
//   var template = body.getAttribute('data-template');
//   console.log(template);
//   document.getElementById("Club-Numbers").value = "option1, option3";
//   setCheckboxesFromHidden();
// }

window.onload = function () {
  var body = document.querySelector("body");
  var template = body.getAttribute("data-template");
  if (template == "wedges" || template == "driving-irons") {
    document.getElementById("Club-Numbers").value = "option1, option3";
    setCheckboxesFromHidden();
  }
};

// document.addEventListener('DOMContentLoaded', function() {
//   let filters = document.querySelectorAll('.list-menu__item');

//   filters.forEach(function(filter) {
//     let productQuantity = parseInt(filter.getAttribute('data-inventory'));
//     if (productQuantity === 0) {
//       filter.style.display = 'none';
//     }
//   });
// });

document.querySelectorAll(".itg_cart_update").forEach((button) => {
  button.addEventListener("click", function () {
    const key = this.dataset.key;
    const inputs = document.querySelectorAll(
      `.update-input[data-key="${key}"]`
    );
    const properties = {};

    inputs.forEach((input) => {
      const name = input.name.replace("properties[", "").replace("]", "");
      properties[name] = input.value;
    });

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: key,
        properties: properties,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("Properties updated:", data);
        location.reload();
      })
      .catch((error) => console.error("Error updating properties:", error));
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var cartItems = document.querySelectorAll(".cart-item");
  var currentOpenPopup = null; // Track the currently open popup

  cartItems.forEach(function (cartItem) {
    var editCartButton = cartItem.querySelector(".itg_edit_cart");
    var cartUpdateButton = cartItem.querySelector(".itg_cart_update");
    var propertiesPopup = cartItem.querySelector(".itg_properties_popup");
    var close_icon = cartItem.querySelector(".itg_cart_close");

    if (editCartButton && cartUpdateButton && propertiesPopup && close_icon) {
      function showPopup(event) {
        if (currentOpenPopup && currentOpenPopup !== propertiesPopup) {
          currentOpenPopup.classList.remove("itg_popup_show");
        }

        propertiesPopup.classList.add("itg_popup_show");
        currentOpenPopup = propertiesPopup;
        event.stopPropagation();
      }

      editCartButton.addEventListener("click", showPopup);
      cartUpdateButton.addEventListener("click", showPopup);

      // Text link under the line buttons, so the edit option is easy to find
      var editGiftLink = cartItem.querySelector(".itg_edit_gift_link");
      if (editGiftLink) {
        editGiftLink.addEventListener("click", function (event) {
          event.preventDefault();
          showPopup(event);
        });
      }

      // Close the popup when the close icon is clicked
      close_icon.addEventListener("click", function (event) {
        propertiesPopup.classList.remove("itg_popup_show");
        currentOpenPopup = null; // Reset the current open popup
        event.stopPropagation(); // Prevent click from propagating
      });

      // Close the popup if clicked outside the cart item
      document.addEventListener("click", function (event) {
        if (!cartItem.contains(event.target)) {
          propertiesPopup.classList.remove("itg_popup_show");
          currentOpenPopup = null; // Reset the current open popup
        }
      });
    }
  });
  // -------------------------------------------------------------------
  // Step-by-step required-field validation.
  // Every custom option must be explicitly chosen before Add to Cart: on
  // each attempt the first incomplete field is highlighted and scrolled
  // into view, and as the customer fills it the walk advances to the next
  // missing field. Fields living inside the closed picker sidebars are
  // surfaced on their visible proxy boxes instead.
  // -------------------------------------------------------------------
  function itgVisibleAnchor(el) {
    if (el.closest('.itg_shaft_sidebar')) {
      var name = (el.getAttribute && el.getAttribute('name')) || '';
      if (name.indexOf('Grip') !== -1 || el.closest('.grip_model')) {
        return document.querySelector('.itg_customize_full.itg_ctm_grip_model') || el;
      }
      if (name.indexOf('Ferrule') !== -1) {
        return document.querySelector('.itg_customize_full.itg_ctm_ctm_ferrule_image') || el;
      }
      return document.querySelector('.itg_shaft_Model') || el;
    }
    if (el.closest('.itg_model_none')) {
      return document.querySelector('.itg_shaft_Model') || el.closest('.itg_customize_flex') || el;
    }
    return el.closest('.itg_customize_part, .itg_customize_full, .itg_customize_flex') || el;
  }

  function itgErrorTextFor(el, anchor) {
    var scopes = [
      el.closest && el.closest('.itg_customize_full, .itg_customize_part'),
      anchor,
      anchor && anchor.closest && anchor.closest('.itg_customize_flex'),
    ];
    for (var i = 0; i < scopes.length; i++) {
      var t = scopes[i] && scopes[i].querySelector && scopes[i].querySelector('.itg-error-text');
      if (t) return t;
    }
    return null;
  }

  function itgCollectRequiredFields() {
    var nodes = document.querySelectorAll(
      '.itg_customize_flex.itg_shaft_flex, select.itg-error, .itg_customize_full.itg_ctm_grip_model.itg-error, .itg_customize_full.itg_ctm_ctm_ferrule_image.itg-error, input#Business'
    );
    var fields = [];
    nodes.forEach(function (node) {
      var field = null;
      if (node.matches('.itg_customize_flex.itg_shaft_flex')) {
        var flexSelect = node.querySelector('select');
        if (node.querySelector('.itg_shaft_flexpart:not(option)')) {
          field = { el: node, check: function () { return !!node.querySelector('.itg_shaft_flexpart.active'); } };
        } else if (flexSelect && flexSelect.options.length > 1) {
          field = { el: flexSelect, check: function () { return !!flexSelect.value; } };
        }
      } else if (node.matches('select.itg-error')) {
        if (node.options.length <= 1) return; // no real choices on this product — not applicable
        if (node.classList.contains('itg_metafiled_val_get')) {
          // Shaft/Adaptor Model is exempt when the brand select says No Upcharge (stock shaft)
          field = { el: node, check: function () {
            var brand = document.querySelector('select.itg_shaft_changees');
            if (brand && brand.value === 'No Upcharge') return true;
            return !!node.value;
          } };
        } else {
          field = { el: node, check: function () { return !!node.value; } };
        }
      } else if (node.matches('.itg_ctm_grip_model')) {
        var gripSelect = document.querySelector('select.SwymGrAddOnProducts[name="properties[Grip Model]"]');
        field = { el: node, check: function () {
          if (gripSelect && gripSelect.options.length > 1) return !!gripSelect.value;
          var img = node.querySelector('img');
          return !!(img && img.getAttribute('src'));
        } };
      } else if (node.matches('.itg_ctm_ctm_ferrule_image')) {
        var ferruleSelect = document.querySelector('select.SwymGrAddOnProducts[name="properties[Ferrule]"]') ||
          document.querySelector('select[name="properties[Ferrule]"]');
        field = { el: node, check: function () {
          if (ferruleSelect && ferruleSelect.options.length > 1) return !!ferruleSelect.value;
          var img = node.querySelector('img');
          return !!(img && img.getAttribute('src'));
        } };
      } else if (node.matches('input#Business')) {
        field = { el: node, check: function () { return node.checked; } };
        field.anchorOverride = node.closest('.itg_business_day');
      }
      if (field) {
        field.anchor = field.anchorOverride || itgVisibleAnchor(field.el);
        field.errText = itgErrorTextFor(field.el, field.anchor);
        fields.push(field);
      }
    });
    return fields;
  }

  function itgClearFieldError(field) {
    field.anchor.classList.remove('Red_color', 'itg-walk-target');
    if (field.el !== field.anchor && field.el.classList) field.el.classList.remove('Red_color');
    if (field.errText) field.errText.classList.add('hide');
  }

  function itgActivateTabFor(anchor) {
    // Fields can live inside an inactive tab panel (.itg_main_step is
    // display:none there, so scrollIntoView would be a no-op). Reuse the
    // theme's own tab switcher by clicking the matching step header.
    var panel = anchor.closest('.itg_main_step');
    if (!panel || panel.classList.contains('active')) return false;
    var stepId = panel.getAttribute('data-step-id');
    if (!stepId) return false;
    var header = document.querySelector('.itg_customize_step_part[data-step-id="' + stepId + '"]');
    if (!header) return false;
    // The Add to Cart click itself re-triggers the active header (the
    // .itg_ctm_addtocart handler), so fadeOut(200) callbacks are still
    // pending on the very panels/footers we are about to fade in; 200ms
    // later they would strip their active/custom-fade classes again and
    // leave the footer at opacity 0. Flush all pending step animations to
    // their end state before switching.
    if (window.jQuery) jQuery('.itg_main_step, .itg_customize_footer').stop(true, true);
    header.click();
    return true;
  }

  function itgReassertTabState(anchor) {
    // Self-heal: if a stray animation callback undid parts of the switch,
    // restore the activated step's panel/footer visibility classes.
    var panel = anchor.closest('.itg_main_step');
    if (!panel) return;
    var stepId = panel.getAttribute('data-step-id');
    if (!stepId) return;
    var header = document.querySelector('.itg_customize_step_part.active[data-step-id="' + stepId + '"]');
    if (!header) return; // this step is no longer the active one — leave it alone
    if (!panel.classList.contains('active')) {
      panel.classList.add('active', 'custom-fade');
      panel.style.display = 'block';
    }
    var footer = document.querySelector('.itg_customize_footer[data-footer-id="' + stepId + '"]');
    if (footer && !footer.classList.contains('active')) {
      footer.classList.add('active', 'custom-fade');
      footer.style.display = 'block';
    }
  }

  function itgShowFieldError(field, scroll) {
    field.anchor.classList.add('Red_color', 'itg-walk-target');
    if (field.el !== field.anchor && field.el.tagName === 'SELECT') field.el.classList.add('Red_color');
    if (field.errText) field.errText.classList.remove('hide');
    if (scroll) {
      var switched = itgActivateTabFor(field.anchor);
      // after a tab switch, wait out the theme's 200ms fade/scroll animation
      setTimeout(function () {
        if (switched) itgReassertTabState(field.anchor);
        field.anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, switched ? 300 : 0);
    }
  }

  var itgWalkActive = false;
  var itgWalkTargetEl = null;
  var itgWalkTimer = null;

  function itgRunValidationWalk() {
    validateBusinessCheckbox();
    var fields = itgCollectRequiredFields();
    if (!fields.length) return true;
    var firstInvalid = null;
    fields.forEach(function (f) {
      if (!firstInvalid && !f.check()) { firstInvalid = f; } else { itgClearFieldError(f); }
    });
    if (!firstInvalid) {
      itgWalkTargetEl = null;
      itgBindWalkAdvance(false);
      return true;
    }
    // Only scroll when the walk moves to a new field, so interacting with
    // the page doesn't keep yanking the viewport back.
    var moved = itgWalkTargetEl !== firstInvalid.el;
    itgWalkTargetEl = firstInvalid.el;
    itgShowFieldError(firstInvalid, moved);
    itgBindWalkAdvance(true);
    return false;
  }

  function itgWalkAdvanceHandler(e) {
    if (e.target.closest && e.target.closest('.add_multiple')) return; // the button does its own fresh run
    if (e.type === 'click' &&
        !(e.target.closest && (e.target.closest('.itg_shaft_flexpart') ||
          e.target.closest('.itg_ctm_shaftmodel_part') ||
          e.target.closest('.itg_ctm_shaftmodel_part_grip_model')))) return;
    clearTimeout(itgWalkTimer);
    itgWalkTimer = setTimeout(function () {
      if (!itgWalkActive) return;
      if (itgRunValidationWalk()) {
        var btn = document.querySelector('.itg_ctm_addtocart .product-form__buttons span.add_multiple, .itg_ctm_addtocart .product-form__buttons button[name="add"], .product-form__buttons button[name="add"]');
        if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 150);
  }

  function itgBindWalkAdvance(active) {
    if (active && !itgWalkActive) {
      itgWalkActive = true;
      document.addEventListener('change', itgWalkAdvanceHandler, true);
      document.addEventListener('click', itgWalkAdvanceHandler, true);
    } else if (!active && itgWalkActive) {
      itgWalkActive = false;
      document.removeEventListener('change', itgWalkAdvanceHandler, true);
      document.removeEventListener('click', itgWalkAdvanceHandler, true);
    }
  }
  window.itgRunValidationWalk = itgRunValidationWalk;

  // FIX [BUNDLE-QTY] itgSilentCheck=true runs the same checks but only returns the result (no auto-click),
  // so the add handler can re-validate on EVERY click instead of trusting the one-time 'error' class gate.
  function validation(event, itgSilentCheck){
    const addtocartBtn = document.querySelector('.itg_ctm_addtocart .product-form__buttons span.add_multiple');
    const walkPassed = itgRunValidationWalk();
    // FIX [BUNDLE-QTY] no auto-click when re-validating from the add handler (would recurse)
    if (walkPassed && addtocartBtn && !itgSilentCheck) {
      addtocartBtn.classList.remove('error');
      addtocartBtn.click();
      // restore so every later attempt re-validates the (possibly changed) fields
      addtocartBtn.classList.add('error');
    }
    return walkPassed; // FIX [BUNDLE-QTY] expose the result so the add handler can re-validate on every click
  }
  document.addEventListener('click', function (e) {
    if(e.target.closest('.add_multiple.error')){
      console.log('error');
       validation(e);
    }else if (e.target.closest('.add_multiple')) {
      // FIX [BUNDLE-QTY] double-submit guard: ignore clicks while an add is already in flight
      if (window.itgBundleAddInFlight) return;
      // FIX [BUNDLE-QTY] re-validate required fields on EVERY click — the 'error' class was a one-time
      // gate removed after the first valid click, letting later invalid submits through unchecked.
      // Only an explicit false blocks, so templates with no required markers behave exactly as before.
      if (validation(e, true) === false) return;

       var arrdata = {};
       var arrbundle = {};
       var SwymGrBundleID = '';
       function generateRandomId() {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let result = '';
            for (let i = 0; i < 7; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                result += characters[randomIndex];
            }
            return `${result}`;
        }        
       const clubBuild = document.querySelector(`input[name="properties[Club Build Info: Brand & Model]"]`);
       if(clubBuild){
          arrdata['Club Build Info: Brand & Model'] = clubBuild.value;
       }
       const playingLength = document.querySelector(`input[type="text"][name="properties[Playing Length]"]`);
       if(playingLength){
          arrdata['Playing Length'] = playingLength.value;
       }
       document.querySelectorAll('.itg_ctm_grip_brand').forEach(select => {
        const value = select.value;
        const fullName = select.getAttribute('name');
        const match = fullName.match(/\[(.+)\]/);
        const extractedName = match ? match[1] : null;
        if(value){
          arrdata[extractedName] = value;
        }
      });
      document.querySelectorAll('.itg_metafiled_val_get').forEach(select => {
        const value = select.value;
        const fullName = select.getAttribute('name');
        const match = fullName.match(/\[(.+)\]/);
        const extractedName = match ? match[1] : null;
        if(value){
          arrdata[extractedName] = select.options[select.selectedIndex].getAttribute('data-title');
        }
      });
      document.querySelectorAll('.shaft_change').forEach(select => {
        const value = select.value;
        const fullName = select.getAttribute('name');
        const match = fullName.match(/\[(.+)\]/);
        const extractedName = match ? match[1] : null;
        if(value){
          arrdata[extractedName] = value;
        }
      });
      document.querySelectorAll('.itg_ctm_length').forEach(select => {
        const value = select.value;
        const fullName = select.getAttribute('name');
        const match = fullName.match(/\[(.+)\]/);
        const extractedName = match ? match[1] : null;
        
        if(value){
          arrdata[extractedName] = value;
          
        }
      });
      
      document.querySelectorAll('.itg_grip_change').forEach(select => {
        const value = select.value;
        const fullName = select.getAttribute('name');
        const match = fullName.match(/\[(.+)\]/);
        const extractedName = match ? match[1] : null;
        if(value){
          arrdata[extractedName] = value;
        }
      });
      

       const AdditionalGrip = document.querySelector(`textarea[name="properties[Additional Note Grip]"]`);
       if(AdditionalGrip){
          arrdata['Additional Note Grip'] = AdditionalGrip.value;
       }
       const AdditionalSettings = document.querySelector(`textarea[name="properties[Adapter Settings]`);
       if(AdditionalSettings){
          arrdata['Additional Settings'] = AdditionalSettings.value;
       }
       const AdditionalFerrule = document.querySelector(`textarea[name="properties[Additional Note Ferrule]"]`);
       if(AdditionalFerrule){
          arrdata['Additional Note Ferrule'] = AdditionalFerrule.value;
       }
       const DesiredLength = document.querySelector(`textarea[name="properties[Desired Length]"]`);
       if(DesiredLength){
          arrdata['Desired Length'] = DesiredLength.value;
       }
       const club_number = document.querySelector('.itg-club-number-option');

       if (club_number) {
        const club_number_checked = club_number.querySelectorAll('input[type="checkbox"]:checked');

        if (club_number_checked.length) {
          let club_number_value = [];
          let club_number_qty = club_number_checked.length;

          club_number_checked.forEach(function (checkbox) {
            const val = checkbox.getAttribute('id');
            club_number_value.push(val); 
          });

          arrdata['Club Number'] = club_number_value.join(', ');

          const formInventory = document.querySelector(
            'form[method="post"] input.product-variant-qty.SwymGrQtyMain'
          );

          if (formInventory) formInventory.value = club_number_qty;
        }
       }
  

       const business = document.querySelector(`input#Business:checked`);
       if(business){
          let businessname = business.getAttribute('data-business');
          arrdata[businessname] = business.value;
       }
        //console.log('one')
      var itemsDataNew = {};
      itemsDataNew['items'] = [];
      // FIX [BUNDLE-QTY] scope lookups to the product-info actually being submitted (was: document-wide
      // first match, which could hit another section's/quick-add's elements)
      const itgProductScope = e.target.closest('product-info') || document;
      let checkQty = (itgProductScope.querySelector('.product-variant-qty') || document.querySelector('.product-variant-qty')).value;
      // FIX [BUNDLE-QTY] the companion multiplier is now resolved at submit time from the SELECTED
      // variant id via the per-variant JSON map rendered in buy-buttons.liquid. The old source,
      // data-addon-quantity on <product-info>, is only written by native 'change' events and goes stale
      // when the <select> changes silently (e.g. browser form-state restoration after the forced reload
      // on back/forward navigation) — which charged customers the DEFAULT variant's Club Number Quantity.
      // The attribute is still written by global.js but is no longer trusted as a quantity source here.
      const itgClubQtyMapEl = itgProductScope.querySelector('script[data-club-qty-map]');
      function itgResolveAddonQty(mainVariantId) {
        // Product doesn't use the Club Number Quantity flow → legacy behavior (hidden qty input),
        // identical to what these products effectively used before (attribute never set for them).
        if (!itgClubQtyMapEl) return { ok: true, qty: checkQty };
        let itgMap = null;
        try { itgMap = JSON.parse(itgClubQtyMapEl.textContent); } catch (itgErr) { itgMap = null; }
        if (!itgMap || !mainVariantId || !Object.prototype.hasOwnProperty.call(itgMap, String(mainVariantId))) {
          // NEVER fall back to data-addon-quantity or another variant's value — block instead.
          console.error('[BUNDLE-QTY] cannot resolve Club Number Quantity for variant', mainVariantId, itgMap);
          return { ok: false };
        }
        const itgRaw = itgMap[String(mainVariantId)];
        const itgNum = Number(itgRaw);
        if (itgRaw === null || itgRaw === '' || !isFinite(itgNum) || itgNum <= 0) {
          // Selected variant has no/zero metafield → same as legacy behavior for metafield-less
          // variants (the attribute used to be removed and the hidden qty input was used).
          return { ok: true, qty: checkQty };
        }
        return { ok: true, qty: itgNum };
      }
      // FIX [BUNDLE-QTY] surface blocking errors through the theme's existing product-form error UI
      function itgShowBundleError(itgMsg) {
        console.error('[BUNDLE-QTY]', itgMsg);
        const itgWrap = itgProductScope.querySelector('.product-form__error-message-wrapper');
        if (itgWrap) {
          itgWrap.removeAttribute('hidden');
          const itgMsgEl = itgWrap.querySelector('.product-form__error-message');
          if (itgMsgEl) itgMsgEl.textContent = itgMsg;
        } else {
          alert(itgMsg);
        }
      }

      function addonsWithRandomId(itgBundleAddonQty){ // FIX [BUNDLE-QTY] multiplier now passed per resolved main variant
          SwymGrBundleID = generateRandomId(); 
          arrbundle['BundleId'] = SwymGrBundleID;
          arrdata['BundleId'] = SwymGrBundleID;
          arrdata['Main'] = 'product'; 
          const SwymGrAddOnProducts = document.querySelectorAll('.SwymGrAddOnProducts');
          if (SwymGrAddOnProducts) {
            SwymGrAddOnProducts.forEach((product, index) => {
                const SwymGrAddOnVariantId = product.value;
                //console.log(SwymGrAddOnProducts,'SwymGrAddOnProducts')
                if (SwymGrAddOnVariantId.trim() === '') { } else{
                  itemsDataNew['items'].push({
                    id: SwymGrAddOnVariantId,
                    quantity: itgBundleAddonQty, // FIX [BUNDLE-QTY] resolved from the selected variant's metafield at submit time
                    properties:{
                      ...arrbundle
                    }
                  });
                }
              });
          }
      } 
      function getOption1Values() {
        const checkboxes = document.querySelectorAll('.pill_option_1 input[type="checkbox"]');
        const radio = document.querySelector('.pill_option_1 input[type="radio"]:checked') || document.querySelector('.product-form__input.dropdown_option_1 select');
        const values = [];
        if (checkboxes.length) {
          checkboxes.forEach(cb => {
            if (cb.checked) values.push(cb.value);
          });
          return values;
        }
        if (radio) return [radio.value];
        return [];
      }
 
      function getOption2Values() {
        const checkboxes = document.querySelectorAll('.pill_option_2 input[type="checkbox"]');
        const radio = document.querySelector('.pill_option_2 input[type="radio"]:checked') || document.querySelector('.product-form__input.dropdown_option_2 select');
        const values = [];
        if (checkboxes.length) {
          checkboxes.forEach(cb => {
            if (cb.checked) values.push(cb.value);
          });
          return values;
        }
        if (radio) return [radio.value];
        return [];
      }
      
      function getOption3Value() {
        const radio = document.querySelector('.pill_option_3 input[type="radio"]:checked');
        if (radio) return radio.value;
        const select = document.querySelector('.product-form__input.dropdown_option_3 select');
        if (select) return select.value;
        return '';
      }


      function getVariantIdFromTitle(dataname) {
        const span = document.querySelector(`.itg_variant_option span[title="${dataname}"]`);
        if (!span) return null;
        const varid = span.dataset.variantId;
        return Number(varid);
      }
      //console.log('getVariantIdFromTitle');
      async function handleAddonVariants() {
        itemsDataNew.items = [];
        const checkOptionType = document.querySelector('.itg_product_variant.dropdown-options');
        const option1 = document.querySelector('fieldset.pill_option_1') || document.querySelector('.product-form__input.dropdown_option_1');
        const option2 = document.querySelector('fieldset.pill_option_2') || document.querySelector('.product-form__input.dropdown_option_2');
        const option3 = document.querySelector('fieldset.pill_option_3') || document.querySelector('.product-form__input.dropdown_option_3');
        const option1Values = getOption1Values();
        const option2Values = getOption2Values();
        const option3Value = getOption3Value();
        const cart = await window.itgGetCart();
        // Fresh duplicate check at add time: a stale button must never create
        // duplicate line items. updateButtonState re-fetches the cart, returns
        // true when the current configuration is already in it, and repaints
        // every add-to-cart button as "Already added".
        if (await window.updateButtonState()) {
          return;
        }
        if (!option1Values.length) {
          //console.warn('Option1 not selected');
          return;
        }
        // FIX [BUNDLE-QTY] empty companion select = hard error instead of a silent skip that shipped a
        // partial bundle (e.g. shaft missing after option re-filtering reset its hidden select). A
        // component blocks only when the customer VISIBLY selected it (its display box shows a
        // title/image — the theme's own convention, also read by updateButtonState) while every matching
        // payload select is empty. Components never selected keep their existing behavior, so optional
        // flows (e.g. putter ferrule) are unaffected.
        const itgComponentPairs = [
          { label: 'shaft',   box: '.shaft_modals_only',                                                   sel: 'select.SwymGrAddOnProducts.itg_ctm_adapter_model' },
          { label: 'grip',    box: '.grip_modals_only, .itg_customize_full.itg_ctm_grip_model',            sel: 'select.SwymGrAddOnProducts.itg_ctm_grip_model, select.SwymGrAddOnProducts.itg_ctm_select_grip_model' },
          { label: 'ferrule', box: '.ferrule_modals_only, .itg_customize_full.itg_ctm_ctm_ferrule_image',  sel: 'select.SwymGrAddOnProducts.itg_ctm_ctm_ferrule' }
        ];
        for (const itgPair of itgComponentPairs) {
          const itgSelects = Array.from(document.querySelectorAll(itgPair.sel));
          if (!itgSelects.length) continue;
          const itgHasValue = itgSelects.some(function (itgSel) { return itgSel.value && itgSel.value.trim() !== ''; });
          if (itgHasValue) continue;
          const itgBox = document.querySelector(itgPair.box);
          if (!itgBox) continue;
          const itgTitleEl = itgBox.querySelector('.itg_shaft_option_title');
          const itgImgEl = itgBox.querySelector('img');
          const itgSelectionShown = (itgTitleEl && itgTitleEl.textContent.trim() !== '') || (itgImgEl && itgImgEl.getAttribute('src'));
          if (itgSelectionShown) {
            itgBox.classList.add('Red_color');
            const itgFlex = itgBox.closest('.itg_customize_flex');
            const itgErrText = itgFlex && itgFlex.querySelector('.itg-error-text');
            if (itgErrText) itgErrText.classList.remove('hide');
            itgShowBundleError('Your selected ' + itgPair.label + ' could not be added. Please re-select the ' + itgPair.label + ' and try again.');
            return;
          }
        }
        if (option1 && option2) {
           //console.log('option1,option2')
          for (const opt1 of option1Values) {
            for (const opt2 of option2Values) {
              const dataname = option3Value
                ? `${opt1} / ${opt2} / ${option3Value}`
                : `${opt1} / ${opt2}`;
              const varid = getVariantIdFromTitle(dataname);
              if (!varid) {
                //console.warn('Variant id not found for:', dataname);
                continue;
              }
              // Skip combinations already in the cart — but only while the
              // shaft/grip/ferrule selections are untouched this session;
              // a re-picked configuration is a legitimate new line item.
              if (!window.shaftUserChanged && !window.gripUserChanged && !window.ferruleUserChanged && window.itgIsVariantInCart(cart, varid)) {
                continue;
              }

              // FIX [BUNDLE-QTY] resolve the multiplier from THIS variant's metafield at submit time;
              // block the whole add if it cannot be resolved (never guess or use another variant's value)
              const itgQtyRes = itgResolveAddonQty(varid);
              if (!itgQtyRes.ok) {
                itgShowBundleError('Could not determine the club quantity for the selected set. Please re-select the set makeup and try again.');
                return;
              }
              addonsWithRandomId(itgQtyRes.qty);

              itemsDataNew.items.push({
                id: varid,
                quantity: Number(checkQty || 1),
                // FIX [BUNDLE-QTY] _qty_source: hidden diagnostic recording which variant id + multiplier
                // was used (underscore prefix keeps it out of cart/checkout display)
                properties: itgClubQtyMapEl ? { ...arrdata, _qty_source: varid + ':' + itgQtyRes.qty } : { ...arrdata }
              });

              // console.log('Added:', varid);
            }
          }
        }else if (option1) {
          //  console.log('option1');
          for (const opt1 of option1Values) {
            const dataname = opt1;
            const varid = getVariantIdFromTitle(dataname);
            if (!varid) continue;
            if (!window.shaftUserChanged && !window.gripUserChanged && !window.ferruleUserChanged && window.itgIsVariantInCart(cart, varid)) {
              continue;
            }

            // FIX [BUNDLE-QTY] resolve the multiplier from THIS variant's metafield at submit time;
            // block the whole add if it cannot be resolved (never guess or use another variant's value)
            const itgQtyRes = itgResolveAddonQty(varid);
            if (!itgQtyRes.ok) {
              itgShowBundleError('Could not determine the club quantity for the selected set. Please re-select the set makeup and try again.');
              return;
            }
            addonsWithRandomId(itgQtyRes.qty);

            itemsDataNew.items.push({
              id: varid,
              quantity: Number(checkQty || 1),
              // FIX [BUNDLE-QTY] _qty_source: hidden diagnostic recording which variant id + multiplier
              // was used (underscore prefix keeps it out of cart/checkout display)
              properties: itgClubQtyMapEl ? { ...arrdata, _qty_source: varid + ':' + itgQtyRes.qty } : { ...arrdata }
            });

            // console.log('Added:', varid);
          }
        }else{
          // console.log('dropdown')
        }

        const safeItems = (itemsDataNew.items || [])
          .filter(i => i && i.id && !isNaN(i.id))
          .map(i => ({
            id: Number(i.id),
            quantity: Number(i.quantity || 1),
            properties: i.properties || {}
          }));

        if (!safeItems.length) {
          // FIX [COMBO-FILTER] safety net: a dropdown picker resolves exactly one combination, so
          // zero resolved items means the selected combination matches no variant — show a visible
          // error instead of the old silent console.warn. Scoped to dropdown pickers only (checked
          // via this product's own markup, not document-wide): on checkbox/pill pickers individual
          // unmatched combinations are skipped legitimately, so their semantics stay unchanged.
          // Aborting here returns normally, so the existing finally releases the in-flight guard.
          if (itgProductScope.querySelector('.product-form__input--dropdown select.select__select')) {
            itgShowBundleError('This combination is unavailable. Please choose a different option.');
            return;
          }
          console.warn('No new variants to add');
          window.updateButtonState();
          return;
        }

        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: safeItems })
        });

        if (!res.ok) {
          if (res.status === 422) {
            document.querySelectorAll('span.add_multiple').forEach(function (btn) {
              btn.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
              btn.classList.add('disabled');
              btn.disabled = true;
            });
            // the add-ons may already be in the cart even though the head was refused
            if (window.itgBundleGuard) window.itgBundleGuard.run();
            return;
          }
          const errText = await res.text();
          console.error("error:", errText);
          if (window.itgBundleGuard) window.itgBundleGuard.run();
          return;
        }
        itgNavigatingToCart = true; // FIX [BUNDLE-QTY] keep the in-flight guard held while the redirect happens
        window.location.href = '/cart';
      }
       
      // FIX [BUNDLE-QTY] mark the add as in flight for the whole async pipeline (getCart + /cart/add.js);
      // cleared in finally on BOTH failure paths so the button never sticks. On success the guard stays
      // held so no second bundle can be added during the redirect to /cart (which happens exactly as before).
      window.itgBundleAddInFlight = true;
      let itgNavigatingToCart = false;
      const itgAddBtn = e.target.closest('.add_multiple');
      if (itgAddBtn) itgAddBtn.classList.add('itg-bundle-adding');
      handleAddonVariants()
        .catch(function (itgErr) { console.error('[BUNDLE-QTY] add-to-cart failed', itgErr); })
        .finally(function () {
          if (itgNavigatingToCart) return;
          window.itgBundleAddInFlight = false;
          if (itgAddBtn) itgAddBtn.classList.remove('itg-bundle-adding');
        });

    }
  });
  
});

document.addEventListener("click", function (event) {
  if (
    event.target.closest(
      ".itg_collection_grid .facets-layout-list--text input[type=checkbox]"
    )
  ) {
    setTimeout(function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 1000);
  }
});

document.querySelectorAll("select.itg_shaft_change").forEach((selectBrand) => {
  selectBrand.addEventListener("change", (event) => {
    let selectedOption = event.target.options[event.target.selectedIndex];
    let vendor = selectedOption.getAttribute("data-vendor");
    //console.log(vendor);
   
    document
      .querySelectorAll(".itg_ctm_shaftmodel_part.active")
      .forEach((activeVariant,index) => {
        let inputElement = activeVariant.querySelector("input");
        let shaftBox = activeVariant.querySelector(".itg_select_box").innerHTML;
        if (inputElement) {
          let inputVendor = inputElement.getAttribute("data-vendor");
          //console.log("inputVendor =" + inputVendor);
          if (vendor != inputVendor) {
            activeVariant.style.display = "none";
          } else {           
            activeVariant.style.display = "block";
            document.querySelector(".itg_shaftChoices").innerHTML = shaftBox;
          }
        }
      });
  });
});






document.addEventListener('DOMContentLoaded', function () {
  const part1Select = document.querySelector('select[name="properties[Material]"]');
  const part2Select = document.querySelector('select[name="properties[Flex]"]');
  const part3Select = document.querySelector('select[name="properties[Brand]"]');
  const part4Select = document.querySelector('select[name="properties[Model]"]');

  function resetOptions(selectEl) {
    selectEl.selectedIndex = 0;
    Array.from(selectEl.options).forEach(opt => {
      opt.style.display = 'none';
    });
  }

  function showUniqueMatchingOptions(selectEl, matchFn) {
    const seen = new Set();
    Array.from(selectEl.options).forEach(opt => {
      const val = opt.value;
      if (!val || val === "") return;

      if (matchFn(opt) && !seen.has(val)) {
        opt.style.display = 'block';
        seen.add(val);
      } else {
        opt.style.display = 'none';
      }
    });
  }
  if(part1Select){
    part1Select.addEventListener('change', function () {
      const selectedVal = this.options[this.selectedIndex].getAttribute('data-part1');
      resetOptions(part2Select);
      resetOptions(part3Select);
      resetOptions(part4Select);

      if (!selectedVal) return;

      showUniqueMatchingOptions(part2Select, opt =>
        opt.getAttribute('data-part1') === selectedVal
      );
      
    });
  }  
  if(part1Select){
    part2Select.addEventListener('change', function () {
      const selectedVal1 = part1Select.options[part1Select.selectedIndex].getAttribute('data-part1');
      const selectedVal2 = this.options[this.selectedIndex].getAttribute('data-part2');

      resetOptions(part3Select);
      resetOptions(part4Select);

      if (!selectedVal2) return;

      showUniqueMatchingOptions(part3Select, opt =>
        opt.getAttribute('data-part1') === selectedVal1 &&
        opt.getAttribute('data-part2') === selectedVal2
      );
    });
  }
  if(part3Select){
    part3Select.addEventListener('change', function () {
      const selectedVal1 = part1Select.options[part1Select.selectedIndex].getAttribute('data-part1');
      const selectedVal2 = part2Select.options[part2Select.selectedIndex].getAttribute('data-part2');
      const selectedVal3 = this.options[this.selectedIndex].getAttribute('data-part3');

      resetOptions(part4Select);

      if (!selectedVal3) return;

      showUniqueMatchingOptions(part4Select, opt =>
        opt.getAttribute('data-part1') === selectedVal1 &&
        opt.getAttribute('data-part2') === selectedVal2 &&
        opt.getAttribute('data-part3') === selectedVal3
      );
    });
  }  
  // Initially hide all options except part1
  if(part2Select || part3Select || part4Select){ 
  [part2Select, part3Select, part4Select].forEach(select => {
    Array.from(select.options).forEach(opt => opt.style.display = 'none');
  });
  }
  // Optionally: remove duplicates visually from part1 too
  if(part1Select){
    const seenPart1 = new Set();
    Array.from(part1Select.options).forEach(opt => {
      const val = opt.value;
      if (val && seenPart1.has(val)) {
        opt.style.display = 'none';
      } else {
        seenPart1.add(val);
      }
    });
  }
});

/*-----------------(Safari-safe adaptor <option> filtering — ITG)--------------------*/
function itgFilterAdaptorSelect(selectEl, optionClass, matchFn) {
  if (!selectEl) return;
  if (!selectEl.itgAdaptorOptionCache) {
    if (!selectEl.querySelector('option.' + optionClass)) return;
    selectEl.itgAdaptorOptionCache = Array.prototype.slice.call(selectEl.options);
  }
  var allOptions = selectEl.itgAdaptorOptionCache;
  var previousValue = selectEl.value;
  var selectedStillValid = false;
  while (selectEl.firstChild) selectEl.removeChild(selectEl.firstChild);
  allOptions.forEach(function (opt) {
    if (!opt.classList.contains(optionClass)) {
      selectEl.appendChild(opt);
      if (opt.value === previousValue) selectedStillValid = true;
      return;
    }
    if (matchFn(opt)) {
      selectEl.appendChild(opt);
      if (opt.value === previousValue) selectedStillValid = true;
    }
  });
  if (selectedStillValid) {
    selectEl.value = previousValue;
  } else {
    selectEl.selectedIndex = 0;
  }
}

/*-----------------(RJ/07/08)--------------------*/
document.addEventListener('DOMContentLoaded',() => {
  var Shaft_Material_selector =  document.querySelector('select.itg_shaft_material');
  if(Shaft_Material_selector){
    Shaft_Material_selector.addEventListener('change',() => {
      var Shaft_Material_val =  Shaft_Material_selector.value;
       const error_text = Shaft_Material_selector.closest('.itg_customize_flex').querySelector('.itg-error-text'); 
      if(!Shaft_Material_val){
        document.querySelector('.itg_customize_flex.itg_shaft_flex').classList.add('itg_disabled');
        Shaft_Material_selector.classList.add('Red_color');
        if(error_text){   
          error_text.classList.remove('hide');
        }
      }else{
        document.querySelector('.itg_customize_flex.itg_shaft_flex').classList.remove('itg_disabled');
        Shaft_Material_selector.classList.remove('Red_color');
        if(error_text){   
          error_text.classList.add('hide');
        }
      }
    });  
  }
 
  const fieldsets = document.querySelectorAll('fieldset.js.product-form__input.pill_option_2, fieldset.js.product-form__input.pill_option_1');
  if (fieldsets.length) {
    fieldsets.forEach((fieldset) => {
      function OneVariant() {
        const checkedBoxes = fieldset.querySelectorAll('input[type="checkbox"]:checked');
        const allBoxes = fieldset.querySelectorAll('input[type="checkbox"]');
        if (checkedBoxes.length === 1) {
          checkedBoxes.forEach(box => box.classList.add('itg_disabled'));
        } else {
          allBoxes.forEach(box => box.classList.remove('itg_disabled'));
        }
      }

      OneVariant();

      fieldset.addEventListener('change', () => {
        OneVariant();
      });
    });
  }

  /*-------------Shaft search js----------------*/
  const inputs = document.querySelectorAll('input.searchInput');
  let debounceTimer;

  if(inputs.length > 0){
    inputs.forEach(function(input){
      input.oninput = function(e){
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function(){
          let inputVal = e.target.value.toLowerCase();
          const container = input.closest('.side-panel-header');
          const suggestionProducts = container.querySelectorAll('.itg_ctm_shaftmodel_part, .itg_ctm_shaftmodel_part_ferrule_model, .itg_ctm_shaftmodel_part_grip_model');
          suggestionProducts.forEach(function(product){
            let data_vendor = (product.getAttribute('data-brand') || '').toLowerCase();
            let data_title = (product.getAttribute('data-title') || '').toLowerCase();

            if(inputVal && (data_vendor.includes(inputVal) || data_title.includes(inputVal))){
              product.classList.remove('hide');
              product.classList.remove('itg_hide');
              product.style.display = 'block';
            } else if(inputVal == '' || inputVal == ' '){
              product.classList.add('hide');
              product.classList.add('itg_hide');
              product.style.display = 'none';
            }else {
              product.classList.add('hide');
              product.classList.add('itg_hide');
              product.style.display = 'none';
            }
          });
        }, 1000);
      };
    });
  }



  const searchSelectors = document.querySelectorAll('.itg_shaft_sidebar.search .itg_ctm_shaftmodel_part');
  if(!searchSelectors)return;
  searchSelectors.forEach(function(searchSelector){
    searchSelector.onclick = function(){     
      const data_brand = this.getAttribute('data-brand');
      const data_flex = this.getAttribute('data-attr-tag');
      const data_shaft_material = this.getAttribute('data-shaft-material');
      const shaft_options = document.querySelector('select.itg_ctm_grip_brand[name="properties[Shaft Material]"]');
      const flex_options = document.querySelectorAll('.itg_customize_flex.itg_shaft_flex .itg_shaft_flexpart'); 
      //const drand_options = document.querySelector('select[name="properties[Shaft Brand]"]');
      const event = new Event('change', { bubbles: true });
      document.querySelector('.itg_shaftChoices').classList.remove('hide');
      if (shaft_options) {
        shaft_options.value = data_shaft_material;
        shaft_options.dispatchEvent(event);
      }
      if(flex_options){
        flex_options.forEach(function(flex_option){
          let flexVal = flex_option.getAttribute('data-shaft-val');
          //console.log(data_flex,'data_flex',flexVal)      
          flex_option.classList.toggle('active',flexVal == data_flex);         
        });
      }
      // if (drand_options) {
      //   drand_options.value = data_brand;
      //   drand_options.dispatchEvent(event);
      // }
      // The material change above clears the brand and auto-picks the first matching
      // shaft's vendor (e.g. Aldila); point the brand at the clicked shaft's vendor instead
      // and re-filter with material + flex + brand. The radio change that follows this
      // click still sets the exact shaft model the customer picked.
      const searchInput = this.querySelector('input');
      const searchVendor = searchInput ? searchInput.getAttribute('data-vendor') : null;
      if (searchVendor) {
        const brandSelects = document.querySelectorAll('select[name="properties[Shaft Brand]"]');
        let brandToTrigger = null;
        brandSelects.forEach(function (brandSelect) {
          const matchOpt = brandSelect.querySelector('option[data-vendor="' + searchVendor + '"]');
          if (matchOpt) {
            brandSelect.value = matchOpt.value;
            brandSelect.classList.remove('Red_color');
            if (!brandToTrigger) brandToTrigger = brandSelect;
          }
        });
        if (brandToTrigger) brandToTrigger.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
  });  
  window.addEventListener('pageshow', function (event) {
    if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
        window.location.reload();
    }
  }); 

  /*---------------Announcement bar Customer Service dropdown — close on outside click--------------------*/
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.itg_announcement_cs[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  
  /*---------------Mobile drawer Need Help popup — close on outside click--------------------*/
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.itg_drawer_help[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  }, true);

  /*---------------Mega menu — Show More toggle--------------------*/
  document.querySelectorAll('.itg-mm-panel__show-more').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const center = e.currentTarget.closest('.itg-mm-panel__center');
      if (!center) return;
      const expanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
      center.querySelectorAll('.itg-mm-show-more-item').forEach((item) => {
        item.classList.toggle('is-hidden', expanded);
      });
      e.currentTarget.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      const label = e.currentTarget.querySelector('.itg-mm-panel__show-more-label');
      if (label) label.textContent = expanded ? 'Show More' : 'Show Less';
    });
  });
  
  /*---------------Mega Menu--------------------*/
  const showMoreBtns = document.querySelectorAll('.itg-toggle-btn');
  showMoreBtns.forEach((showMoreBtn) => {
    showMoreBtn.addEventListener('click', (e) => {
      const menu_closest = e.target.closest('.itg_mega_menu');
      if (!menu_closest) return;
      const toggleText = menu_closest.querySelector('.itg-toggle-btn span');
      const showMoreItems = menu_closest.querySelectorAll('.itg-show-more');
      if (toggleText.classList.contains('show-less')) {
        showMoreItems.forEach((item) => {
          item.classList.add('hide');
        });
        toggleText.textContent = 'Show More';
        toggleText.classList.remove('show-less');
      } else {      
        showMoreItems.forEach((item) => {
          item.classList.remove('hide');
        });
        toggleText.textContent = 'Show Less';
        toggleText.classList.add('show-less');
      }
    });
  });
  /*-----------------(custom-driver-fa-template)------------------*/
  const club_type = document.querySelector('.itg_shaft_flex .itg_select_main select');
  const adapterSelect = document.querySelector('.itg_select_main select#adapter-model');  
  if(club_type && adapterSelect){
    const adapterOptions = adapterSelect.querySelectorAll('option.adapter-mode-option');
    club_type.addEventListener('change',(option)=>{
      const shaftValue = option.target.value      
      if(shaftValue){          
        if(adapterSelect) {
        const defaultOption = adapterSelect.querySelector('option[data-option="Choose Option"]');
        defaultOption.selected = true;   
        } 
        adapterOptions.forEach((adapterOption)=>{
          let adapterOptionVal = adapterOption.value
          if(shaftValue == adapterOptionVal){
            adapterOption.classList.remove('hide');
          }else{
            adapterOption.classList.add('hide');
          }
        });
      }else{
        // console.log(shaftValue,'no');
       adapterOptions.forEach((adapterOption)=> adapterOption.classList.remove('hide'));   
      } 
      itgFilterAdaptorSelect(adapterSelect, 'adapter-mode-option', function (opt) {
        return !shaftValue || opt.value == shaftValue;
      }); 
    });
  }
  if(adapterSelect){
    adapterSelect.addEventListener('change',(e)=>{
      const selectedOption = e.target.options[e.target.selectedIndex];  
      const selectedTitle = selectedOption.getAttribute('variant-title');
      const selectedImg = selectedOption.getAttribute('data-variant-img');
      const selectedPrice= selectedOption.getAttribute('data-variant-price');
      const selectedId = selectedOption.getAttribute('id');
      if(selectedTitle != null && selectedImg != null && selectedPrice != null){
        const selectedContent = `<span class="itg_shaft_selected">
                                    <span class="itg_shaft_option_title">${selectedTitle}</span>
                                    <span class="itg_shaft_option_price">${selectedPrice}</span>
                                  </span>
                                  <img alt="${selectedTitle}" src="${selectedImg}" class="selectedShaftImage">`
        document.querySelector('.itg_shaft_Model .itg_select_box').innerHTML = selectedContent;
        document.querySelector('select.itg_shaft_change_value.SwymGrAddOnProducts option[data-variant-metafield="'+selectedId+'"]').selected = true;
      }  

    });
  }
  let currentURL = window.location.href
  const soldOutVariant = document.querySelector('.product-form__submit[disabled]');
  if(currentURL.includes('?variant') && soldOutVariant){ 
    const updatedURL= currentURL.split('?variant')[0];
    window.location.href = updatedURL 
  } 
  const ctm_lengths = document.querySelectorAll('.itg_ctm_length');
  const grip_brands = document.querySelectorAll('.itg_customize_flex select.itg_grip_change');
 
  ctm_lengths.forEach(function(ctm_length){
    ctm_length.addEventListener('change',function(e){
      const checkVal = e.target.value;
       const error_text = ctm_length.closest('.itg_customize_flex').querySelector('.itg-error-text');
      //console.log('ee',ctm_length)
      if(!checkVal){
        ctm_length.classList.add('Red_color');
        if(error_text){ 
          error_text.classList.remove('hide');
        }  
      }else{
        ctm_length.classList.remove('Red_color');
        if(error_text){   
          error_text.classList.add('hide');
        }  
      }

    });
  });
 
  
});

/*-----------------------(RJ/12/11)------------------------*/
 
if(suffix == 'custom-driver-fw-hy' || suffix == 'new-custom-driver-fairway'){
  const shaft_flexs =  document.querySelectorAll('.itg_customize_flex.itg_shaft_flex .itg_shaft_flexpart');
  if(shaft_flexs.length > 0){
    shaft_flexs.forEach(function(shaft_flex){
      shaft_flex.addEventListener('click',function(){
        const selectors = document.querySelectorAll('.itg_selector');
        // setTimeout(function(){
        //   document.querySelector('.itg_ctm_shaftmodel_part_grip_model:not(.hide) label.itg_ctm_shaftmodel_label').click();
        // },100);  
        if(selectors.length > 0){
            selectors.forEach(function(selector){
              selector.classList.remove('itg_disabled');
            });
        }
        
      });
    });
  }
} 
if(suffix == 'custom-taylormade-putters'){
  // const drand_selector_search =  document.querySelector('.side-panel-header .itg_ctm_flexmodel label.itg_ctm_shaftmodel_label');
  // if(drand_selector_search){
  //     drand_selector_search.addEventListener('click',function(drand){
  //         const selectors = document.querySelectorAll('.itg_selector');
  //         if(selectors.length > 0){
  //             selectors.forEach(function(selector){
  //               selector.classList.remove('itg_disabled');
  //             });
  //         }
        
  //     }); 
  // }
  const brand_selector_shaft = document.querySelector('select.itg_shaft_change.itg_ctm_grip_brand');
  if(brand_selector_shaft){
      brand_selector_shaft.addEventListener('change',function(drand){
         const drandVal = drand.target.value
         const selector = document.querySelector('.itg_selector');
         if(drandVal){       
          selector.classList.remove('itg_disabled');
         }else{
          selector.classList.add('itg_disabled');
         }       
      }); 
  }
  const brand_selector = document.querySelector('select.itg_shaft_change.custom-taylormade-putters');
  if(brand_selector){
    brand_selector.addEventListener('change',function(brand){
      const select = brand.target;
      const selectedOption = select.options[select.selectedIndex];
      const brandVendor = selectedOption.textContent.trim(); 
      const selectElement = document.querySelector('select.SwymGrAddOnProducts[name="properties[Shaft Model]"]');
      if (selectElement) {
          const option = selectElement.querySelector('option[data-vendor="' + brandVendor + '"]');
          if (option) {
              option.selected = true;
          } else {
              console.error("Option with data-vendor not found.");
          }
      } else {
          console.error("Select element not found.");
      }
    });
  }
} 

document.addEventListener('DOMContentLoaded', function() { 
  window.shaftUserChanged = false;
  window.gripUserChanged = false;
  window.ferruleUserChanged = false;

  function setSelectedFromInputs() {
    document.querySelectorAll('.itg_variant_option span[selected="selected"]')
      .forEach(el => el.removeAttribute('selected'));
    const option1Checkbox = document.querySelectorAll('.pill_option_1 input[type="checkbox"]:checked');
    const option1Radio = document.querySelector('.pill_option_1 input[type="radio"]:checked') || document.querySelector('.product-form__input.dropdown_option_1 select');
    const option2Checkbox = document.querySelectorAll('.pill_option_2 input[type="checkbox"]:checked');
    const option2Radio = document.querySelector('.pill_option_2 input[type="radio"]:checked') || document.querySelector('.product-form__input.dropdown_option_2 select');
    const option3Radio = document.querySelector('.pill_option_3 input[type="radio"]:checked') || document.querySelector('.product-form__input.dropdown_option_3 select');

    let option1Values = [];
    if (option1Checkbox.length) {
      option1Values = Array.from(option1Checkbox).map(el => el.value);
    } else if (option1Radio) {
      option1Values = [option1Radio.value];
    }

    let option2Values = [];
    if (option2Checkbox.length) {
      option2Values = Array.from(option2Checkbox).map(el => el.value);
    } else if (option2Radio) {
      option2Values = [option2Radio.value];
    }

    option1Values.forEach(opt1 => {
      option2Values.forEach(opt2 => {
        const title = option3Radio
          ? `${opt1} / ${opt2} / ${option3Radio.value}`
          : `${opt1} / ${opt2}`;

        document.querySelectorAll(`.itg_variant_option span[title="${title}"]`)
          .forEach(span => span.setAttribute('selected', 'selected'));
      });
    });
  }
  setSelectedFromInputs();
  const addOnSelector = document.querySelector('.SwymGrAddOnProducts.itg_ctm_adapter_model');
  if((suffix === 'custom-driver-fairway-woo') && addOnSelector){ 
  addOnSelector.addEventListener('change', function (e) {
    const val = e.target.value;
    const select = e.target;
    const selectedOption = select.options[select.selectedIndex];
    const selected_title = selectedOption.getAttribute('title');
    const selected_price = selectedOption.getAttribute('data-variant-price');
    const selected_image_src = selectedOption.getAttribute('data-variant-img');
    const adaptorSettings = document.querySelector('select.itg_ctm_length[name="properties[Adaptor Settings]"] option[data-val="Choose Option"]');
    if(adaptorSettings) adaptorSettings.selected = true;
    const adaptor_settings = document.querySelectorAll('select.itg_ctm_length[name="properties[Adaptor Settings]"] option.adaptor-settings');
    if (adaptor_settings.length > 0) {
      adaptor_settings.forEach(function (option) {
        const variantId = option.getAttribute('variantid');
        if (val === variantId) {
          option.classList.remove('hide');
        } else {
          option.classList.add('hide');
        }
      });
    }
    document.querySelector('.itg_shaft_Model span.itg_shaft_option_title').innerHTML = selected_title;
    document.querySelector('.itg_shaft_Model .itg_shaftChoices span.itg_shaft_option_price').innerHTML = selected_price;
    document.querySelector('.itg_shaft_Model .itg_shaftChoices img.selectedShaftImage').setAttribute('src', selected_image_src);
    const parent = select.closest('.itg_shaft_model');
    const errorBox = parent.querySelector('.itg-error-text');
    if(val){
      select.classList.remove('Red_color');
      errorBox.classList.add('hide');
    }else{
      select.classList.add('Red_color');
      errorBox.classList.remove('hide'); 
    }
  });


    const club_type = document.querySelector('select.itg_shaft_material[name="properties[club type]"]');
    const club_build = document.querySelector('select.itg_shaft_change[name="properties[Club Build Info: Brand & Model]"]');
    const club_build_options = document.querySelectorAll('select.itg_shaft_change[name="properties[Club Build Info: Brand & Model]"] option.club-build-option');
    const check_combinations = document.querySelectorAll('select.SwymGrAddOnProducts.itg_ctm_adapter_model option.adapter-model-option, .itg_ctm_flexmodel.custom-driver-fairway-woo .itg_ctm_shaftmodel_part');

    if (club_type) {
        club_type.addEventListener('change', function (e) {
            const club_type_val = e.target.value;           
            //document.querySelector('select.itg_shaft_change[name="properties[Club Build Info: Brand & Model]"] option[data-val="Choose Option"]').selected = true;         
            const adaptorSettings = document.querySelector('select.itg_ctm_length[name="properties[Adaptor Settings]"] option[data-val="Choose Option"]');  
            const adaptorModel = document.querySelector('select.SwymGrAddOnProducts.itg_ctm_adapter_model option[data-val="Choose Option"]');
            if(adaptorSettings) adaptorSettings.selected = true;
            if(adaptorModel) adaptorModel.selected = true;
            // club_build_options.forEach(function (opt) {
            //     const opt_type = opt.getAttribute('club-type');             
            //     if (opt_type.includes(club_type_val)) {                
            //         opt.classList.remove('hide');
            //     } else {
            //         opt.classList.add('hide');
            //     }
            // });
            check_combinations.forEach(function (opt) {
                const opt_type = opt.getAttribute('club-type');
                if (opt_type.includes(club_type_val)) {
                    opt.classList.remove('hide');
                } else {
                    opt.classList.add('hide');
                }
            });
            // Safari-safe: physically detach/re-attach the adaptor <option> nodes.
            // (The .hide toggling above still runs for the .itg_ctm_shaftmodel_part DIVs,
            //  which are not native <option>s; Safari ignores .hide on <option>.)
            itgFilterAdaptorSelect(addOnSelector, 'adapter-model-option', function (opt) {
                return (opt.getAttribute('club-type') || '').includes(club_type_val);
            });
        });
    }
 
    // if (club_build) {
    //     club_build.addEventListener('change', function (e) {
    //         const club_build_val = e.target.value;
    //         document.querySelector('select.SwymGrAddOnProducts.itg_ctm_adapter_model option[data-val="Choose Option"]').selected = true;
    //         check_combinations.forEach(function (opt) {
    //             const vendor = opt.getAttribute('club-vendor');

    //             if (vendor.includes(club_build_val)) {
    //                 opt.classList.remove('hide');
    //             } else {
    //                 opt.classList.add('hide');
    //             }
    //         });
    //     });
    // }

  }
  /* check variant in cart page */
 
  // cart helpers: window.itgGetCart / window.itgIsVariantInCart (file top)

  // ---------------- self-enforcing button state ----------------
  // itgPaint() is the ONLY legitimate writer of button text/class; it sets
  // an internal expected state that per-button MutationObservers check. Any
  // foreign rewrite away from an expected "Already added" is reverted and
  // logged to window.__itgMutations (ring buffer, debug modes surface it).
  var itgExpectedAdded = null; // authoritative expected state; null = unknown
  window.__itgMutations = [];

  function itgSetExpected(added) {
    itgExpectedAdded = added === true;
  }

  function itgPaint(btn, added) {
    btn.__itgPainting = true;
    if (added) {
      btn.textContent = 'Already added';
      btn.classList.add('disabled');
    } else {
      if (btn.hasAttribute('preorder')) {
        btn.textContent = btn.getAttribute('preordertext');
      } else {
        btn.textContent = 'Add to cart';
      }
      btn.disabled = false;
      btn.classList.remove('disabled');
    }
    // clear on a macrotask: the observer callback (microtask) still sees the
    // flag set for our own mutations
    setTimeout(function () { btn.__itgPainting = false; }, 0);
  }

  function itgRecordMutation(m, btn) {
    window.__itgMutations.push({
      time: new Date().toISOString(),
      type: m.type,
      attr: m.attributeName || '',
      oldValue: m.oldValue == null ? '' : String(m.oldValue).slice(0, 120),
      text: (btn.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60),
      // NOTE: MutationObserver runs as a microtask, so this stack is the
      // observer's, not the writer's call stack — the record data + timing
      // are what identify the writer behaviorally.
      stack: String(new Error().stack || '').split('\n').slice(1, 6).join(' | ')
    });
    if (window.__itgMutations.length > 50) window.__itgMutations.shift();
  }

  function itgEnsureObservers() {
    if (typeof MutationObserver === 'undefined') return;
    document.querySelectorAll('span.add_multiple').forEach(function (btn) {
      if (btn.__itgObserved) return;
      btn.__itgObserved = true;
      var mo = new MutationObserver(function (muts) {
        // Only the "Already added" state is enforced; legitimate flips to
        // "Add to cart" happen via itgPaint after itgSetExpected(false), so
        // the observer never fights variant changes or cart removals.
        if (itgExpectedAdded !== true) return;
        if (btn.__itgPainting) return;
        var text = (btn.textContent || '').trim();
        if (text === 'Already added' && btn.classList.contains('disabled')) return;
        for (var i = 0; i < muts.length; i++) itgRecordMutation(muts[i], btn);
        itgPaint(btn, true);
      });
      mo.observe(btn, {
        childList: true,
        subtree: true,
        characterData: true,
        characterDataOldValue: true,
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
    });
  }

   window.updateButtonState = async function updateButtonState() {
    var cart = await window.itgGetCart();
     //console.log(cart,'cart');
    const selectedSpans = document.querySelectorAll('.itg_variant_option span[selected="selected"]');
    // the page renders the buy button twice (customize tab footer + product
    // info column) — every instance must carry the same state
    const btns = document.querySelectorAll('span.add_multiple');


    const shaftTitleEl = document.querySelector('.shaft_modals_only .itg_shaft_option_title');
    const shaftPriceEl = document.querySelector('.shaft_modals_only .itg_shaft_option_price');
    const shaftTitle = shaftTitleEl ? shaftTitleEl.textContent.trim() : '';
    const shaftPrice = shaftPriceEl ? shaftPriceEl.textContent.trim() : '';

    // console.log('shaftTitle:', shaftTitle, '| shaftPrice:', shaftPrice);

    let shaftInCart = true;

    if(shaftTitle && window.shaftUserChanged) {
      shaftInCart = cart.items.some(function(item) {
          if(!item.properties || !item.properties['Shaft Model']) return false;
          const cartShaftVal = item.properties['Shaft Model'];
          const cartShaftTitle = cartShaftVal.includes('-~')
              ? cartShaftVal.split('-~')[0].trim()
              : cartShaftVal.trim();
          return cartShaftTitle === shaftTitle;
      });
    }

    const gripTitleEl = document.querySelector('.grip_modals_only .itg_shaft_option_title');
    const gripPriceEl = document.querySelector('.grip_modals_only .itg_shaft_option_price');
    const gripTitle = gripTitleEl ? gripTitleEl.textContent.trim() : '';
    const gripPrice = gripPriceEl ? gripPriceEl.textContent.trim() : '';

    // console.log('gripTitle:', gripTitle, '| gripPrice:', gripPrice);
    let gripInCart = true;
    if(gripTitle && window.gripUserChanged) {
        gripInCart = cart.items.some(function(item) {
            if(!item.properties || !item.properties['Grip Model']) return false;
            const cartGripVal = item.properties['Grip Model'];
            const cartGripTitle = cartGripVal.includes('-~')
                ? cartGripVal.split('-~')[0].trim()
                : cartGripVal.trim();
            return cartGripTitle === gripTitle;
        });
    }

    const ferruleTitleEl = document.querySelector('.ferrule_modals_only .itg_shaft_option_title');
    const ferrulePriceEl = document.querySelector('.ferrule_modals_only .itg_shaft_option_price');
    const ferruleTitle = ferruleTitleEl ? ferruleTitleEl.textContent.trim() : '';
    const ferrulePrice = ferrulePriceEl ? ferrulePriceEl.textContent.trim() : '';

    // console.log('ferruleTitle:', ferruleTitle, '| ferrulePrice:', ferrulePrice);

    let ferruleInCart = true;
    if(ferruleTitle && window.ferruleUserChanged) {
        ferruleInCart = cart.items.some(function(item) {
            if(!item.properties || !item.properties['Ferrule']) return false;
            const cartFerruleVal = item.properties['Ferrule'];
            const cartFerruleTitle = cartFerruleVal.includes('-~')
                ? cartFerruleVal.split('-~')[0].trim()
                : cartFerruleVal.trim();
            return cartFerruleTitle === ferruleTitle;
        });
    }

    // Variant ids come from the LIVE option inputs — the same source the add
    // flow (handleAddonVariants) reads — so the paint and the duplicate-add
    // guard can never disagree. iOS WebKit restores checked pills on
    // back-nav/reload without firing change, which left the span[selected]
    // markers stale and the button stuck on "Add to cart" while the add was
    // refused. null → no input-derivable selection: fall back to the
    // server-rendered span markers (initial-load default).
    let selectedVariantIds = window.itgGetSelectedVariantIds();
    const idsFromInputs = selectedVariantIds !== null;
    if (!idsFromInputs) {
      selectedVariantIds = Array.from(selectedSpans).map(span => span.innerHTML.trim());
    }

    let alreadyAdded = false;
    if (btns.length) {
      if (!selectedVariantIds.length) {
        itgSetExpected(false);
        btns.forEach(function (btn) { itgPaint(btn, false); });
        itgEnsureObservers();
        return false;
      }
      const allInCart = selectedVariantIds.every(variantId => window.itgIsVariantInCart(cart, variantId));
      alreadyAdded = allInCart && shaftInCart && gripInCart && ferruleInCart;
      itgSetExpected(alreadyAdded);
      btns.forEach(function (btn) { itgPaint(btn, alreadyAdded); });
      itgEnsureObservers();
    }
    //console.log('[ITG] button state:', cart.items.length, 'cart items | alreadyAdded:', alreadyAdded, '| buttons painted:', btns.length);
    // On-device diagnostics without a remote inspector: append ?itgdebug=1 to
    // the product URL to see the same numbers as the console line.
    if (itgDebugHas('1')) {
      var badge = document.getElementById('itg-debug-badge');
      if (!badge) {
        badge = document.createElement('div');
        badge.id = 'itg-debug-badge';
        badge.style.cssText = 'position:fixed;bottom:8px;left:8px;z-index:99999;background:#000;color:#0f0;font:11px/1.4 monospace;padding:6px 8px;border-radius:4px;opacity:0.85;pointer-events:none;';
        document.body.appendChild(badge);
      }
      badge.textContent = 'cart items: ' + cart.items.length +
        ' | alreadyAdded: ' + alreadyAdded +
        ' | buttons: ' + btns.length +
        ' | ids: ' + selectedVariantIds.length + (idsFromInputs ? ' (inputs)' : ' (spans)') +
        ' | spans sel: ' + selectedSpans.length +
        ' | mut: ' + window.__itgMutations.length +
        ' | inline: ' + (window.__itgInlineRan === true) +
        ' | ' + new Date().toLocaleTimeString();
    }
    // ?itgdebug=alert: unmissable popup with per-button paint state.
    if (itgDebugHas('alert')) {
      var dbgLines = [
        '[ITG DEBUG]',
        'cart items: ' + cart.items.length,
        'alreadyAdded: ' + alreadyAdded,
        'buttons: ' + btns.length,
        'ids: ' + selectedVariantIds.length + (idsFromInputs ? ' (inputs)' : ' (spans)'),
        'spans sel: ' + selectedSpans.length,
        'time: ' + new Date().toLocaleTimeString()
      ];
      btns.forEach(function (dbgBtn, dbgIndex) {
        dbgLines.push(
          'btn[' + dbgIndex + '] "' + (dbgBtn.textContent || '').replace(/\s+/g, ' ').trim() + '"' +
          ' | disabled class: ' + dbgBtn.classList.contains('disabled') +
          ' | visible: ' + (dbgBtn.offsetParent !== null)
        );
      });
      dbgLines.push('inline ran: ' + (window.__itgInlineRan === true));
      dbgLines.push('liquid rendered: ' + (btns.length ? (btns[0].getAttribute('data-itg-rendered') || 'n/a') : 'n/a'));
      var navEntry = null;
      try { navEntry = (performance.getEntriesByType('navigation') || [])[0] || null; } catch (eNav) {}
      if (navEntry) {
        dbgLines.push('nav transferSize: ' + navEntry.transferSize +
          (navEntry.transferSize === 0 ? ' (likely disk/memory cache)' : '') +
          (typeof navEntry.deliveryType !== 'undefined' ? ' | deliveryType: ' + (navEntry.deliveryType || 'network') : ''));
      }
      dbgLines.push('mutations: ' + window.__itgMutations.length);
      if (window.__itgMutations.length) {
        var lastMut = window.__itgMutations[window.__itgMutations.length - 1];
        dbgLines.push('last mut: ' + lastMut.type + ' ' + lastMut.attr + ' old:"' + lastMut.oldValue + '" now:"' + lastMut.text + '"');
      }
      alert(dbgLines.join('\n'));
    }
    return alreadyAdded;
  }

  // Server-rendered button state via the Section Rendering API. The Liquid
  // in buy-buttons/itg-already-added is the source of truth for the neutral
  // (nothing re-picked) state; this fetches the product section fresh and
  // swaps text + disabled class into every live button. Both buttons live in
  // the same product section, so one section_id covers them. Ownership rule
  // (keeps Liquid and the JS repaint from fighting): once the shopper
  // re-picks a shaft/grip/ferrule this session, Liquid cannot know that, so
  // this defers entirely to updateButtonState — which applies the same
  // variant-id rule plus the line-item property comparison.
  function itgRefreshButtonsFromServer() {
    if (window.shaftUserChanged || window.gripUserChanged || window.ferruleUserChanged) {
      updateButtonState();
      return;
    }
    // When the live option inputs yield a selection, only the client can see
    // ALL of it. The ?variant= param below is read from
    // input.product-variant-id, which Dawn updates asynchronously (or never,
    // on multi-select club-number templates) — at change time it often still
    // holds the PREVIOUS variant. Rendering from that stale id painted
    // "Already added" over a different, freshly selected variant, and the
    // expected-state observer then enforced the wrong paint. The server
    // render stays only for the neutral no-selection state, where Liquid's
    // variant-id rule is the same one the client would apply.
    if (window.itgGetSelectedVariantIds() !== null) {
      updateButtonState();
      return;
    }
    var anyBtn = document.querySelector('span.add_multiple');
    if (!anyBtn || !anyBtn.id || anyBtn.id.indexOf('ProductSubmitButton-') !== 0) return;
    var sectionId = anyBtn.id.replace('ProductSubmitButton-', '');
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now();
    var variantInput = document.querySelector('input.product-variant-id[name="id"]');
    if (variantInput && variantInput.value) url += '&variant=' + encodeURIComponent(variantInput.value);
    fetch(url, { cache: 'no-store' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelectorAll('span.add_multiple');
        if (!fresh.length) return;
        var serverAdded = false;
        for (var fi = 0; fi < fresh.length; fi++) {
          if (fresh[fi].getAttribute('data-itg-liquid-state') === 'true') { serverAdded = true; break; }
        }
        // The server only sees the single ?variant= id, which cannot carry a
        // multi-select pill configuration — so a server "false" never
        // overwrites a client-verified "Already added"; re-verify against a
        // fresh cart instead. A server "true" (variant-id membership) is
        // always trustworthy and applies below.
        if (!serverAdded && itgExpectedAdded === true) {
          updateButtonState();
          return;
        }
        itgSetExpected(serverAdded);
        document.querySelectorAll('span.add_multiple').forEach(function (el, i) {
          var src = fresh[i] || fresh[0];
          el.__itgPainting = true;
          el.textContent = (src.textContent || '').replace(/\s+/g, ' ').trim();
          if (src.classList.contains('disabled')) {
            el.classList.add('disabled');
          } else {
            el.classList.remove('disabled');
          }
          var liquidState = src.getAttribute('data-itg-liquid-state');
          if (liquidState !== null) el.setAttribute('data-itg-liquid-state', liquidState);
          setTimeout(function () { el.__itgPainting = false; }, 0);
        });
        itgEnsureObservers();
      })
      .catch(function () {
        // network/parse failure: the JS fallback below still owns the paint
        updateButtonState();
      });
  }
  window.itgRefreshButtonsFromServer = itgRefreshButtonsFromServer;

  // Seed the expected state from the server-rendered attribute and start
  // enforcing immediately — before the first async cart fetch resolves.
  (function () {
    var seeded = document.querySelector('span.add_multiple[data-itg-liquid-state]');
    if (seeded) {
      itgSetExpected(seeded.getAttribute('data-itg-liquid-state') === 'true');
      itgEnsureObservers();
    }
  })();

  updateButtonState();

  // Defensive repaints: cover any markup assembled after document-ready and
  // bfcache restores that skip the reload handler. pageshow runs
  // unconditionally (not just e.persisted): WebKit restores checked
  // pills/selects on back-nav and reload after the load event without firing
  // change events, and pageshow is the earliest reliable moment to read the
  // restored inputs.
  window.addEventListener('load', function () { updateButtonState(); });
  window.addEventListener('pageshow', function () { updateButtonState(); });

  // Cart drawer mutations (remove / quantity change / other adds) must
  // refresh the button state without a page reload — server-rendered via
  // the Section Rendering API; updateButtonState remains the fallback.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      itgRefreshButtonsFromServer();
    });
  }

  document.addEventListener('change', function(e) {
      if (!e.target.matches('variant-selects fieldset.product-form__input input, variant-selects.dropdown-options select')) return;
      // console.log('wee');
      function clearSelectedSpans() {
          document.querySelectorAll('.itg_variant_option span[selected="selected"]').forEach(el => el.removeAttribute('selected'));
      }
      function selectSpanByTitle(title) {
          // console.log(title, 'title');
          document.querySelectorAll(`.itg_variant_option span[title="${title}"]`).forEach(el => el.setAttribute('selected', 'selected'));
      }
      const option1Checkboxes = document.querySelectorAll('.pill_option_1 input[type="checkbox"]:checked');
      const option1Radio = document.querySelector('.pill_option_1 input[type="radio"]:checked');
      const option1Dropdown = document.querySelector('.product-form__input.dropdown_option_1 select');
      let option1Values = [];
      if (option1Checkboxes.length) {
          option1Checkboxes.forEach(cb => option1Values.push(cb.value));
      } else if (option1Radio) {
          option1Values = [option1Radio.value];
      } else if (option1Dropdown && option1Dropdown.value) {
          option1Values = [option1Dropdown.value];
      }
      const option2Checkboxes = document.querySelectorAll('.pill_option_2 input[type="checkbox"]:checked');
      const option2Radio = document.querySelector('.pill_option_2 input[type="radio"]:checked');
      const option2Dropdown = document.querySelector('.product-form__input.dropdown_option_2 select');
      let option2Value = '';
      if (option2Checkboxes.length) {
          option2Checkboxes.forEach(cb => option2Value = cb.value);
      } else if (option2Radio) {
          option2Value = option2Radio.value;
      } else if (option2Dropdown && option2Dropdown.value) {
          option2Value = option2Dropdown.value;
      }
      const option3Radio = document.querySelector('.pill_option_3 input[type="radio"]:checked');
      const option3Dropdown = document.querySelector('.product-form__input.dropdown_option_3 select');
      let option3Value = '';
      if (option3Radio) {
          option3Value = option3Radio.value;
      } else if (option3Dropdown && option3Dropdown.value) {
          option3Value = option3Dropdown.value;
      }
      const option1El = document.querySelector('fieldset.pill_option_1') || document.querySelector('.product-form__input.dropdown_option_1 select');
      const option2El = document.querySelector('fieldset.pill_option_2') || document.querySelector('.product-form__input.dropdown_option_2 select');
      clearSelectedSpans();
      if (option1El && option2El) {
          const inputCheckbox = document.querySelectorAll('fieldset input[type="checkbox"]:checked');
          if (inputCheckbox.length) {
              inputCheckbox.forEach(checkbox => {
                  option1Values.forEach(opt1 => {
                      const dataname = option3Value
                          ? `${opt1} / ${checkbox.value} / ${option3Value}`
                          : `${opt1} / ${checkbox.value}`;
                      selectSpanByTitle(dataname);
                  });
              });
          } else {
              if (option2Value) {
                  option1Values.forEach(opt1 => {
                      const dataname = option3Value
                          ? `${opt1} / ${option2Value} / ${option3Value}`
                          : `${opt1} / ${option2Value}`;
                      // console.log(dataname, 'dataname');
                      selectSpanByTitle(dataname);
                  });
              }
          }
      } else if (option1El) {
          option1Values.forEach(val => selectSpanByTitle(val));
      }
      updateButtonState();
      // variant change: authoritative server-rendered state (Section
      // Rendering API); the updateButtonState above stays as the fallback.
      itgRefreshButtonsFromServer();
      setTimeout(function(){
          const checkBtn = document.querySelector('div[role="status"] .price');
          const customBtn = document.querySelector('span.add_multiple');
          if(checkBtn && customBtn){
              if(checkBtn.classList.contains('price--sold-out')){
                  customBtn.textContent = "Sold Out";
                  customBtn.classList.add("disabled");
              }
          }
      }, 1000); 
  });
 
    const scrollBoxes = document.querySelectorAll(".itg_ctm_product_page fieldset.js.product-form__input")
    function checkScroll() {
     if(scrollBoxes.length){  
      scrollBoxes.forEach(box => {
        const boxHeight = box.clientHeight;
        if (boxHeight >= 400) {
          box.classList.add("show-scrollbar");
        } else {
          box.classList.remove("show-scrollbar");
        }
      });
     }  
    }
    checkScroll();
    window.addEventListener("resize", checkScroll);
 
    // /*----------------(accordion-js/17/02)-----------------*/
    // const itg_accordions_titles = document.querySelectorAll('.itg_accordions_title');
    // if (itg_accordions_titles.length) {
    //   itg_accordions_titles.forEach(function(title) {
    //     title.addEventListener('click', function() {
    //       const content = this.nextElementSibling;
    //       if (content && content.classList.contains('itg_accordions_content')) {
    //         content.classList.toggle('hide');
    //         checkHeight();
    //       }
    //       this.classList.toggle('active-tab');
    //     });
    //   });
    // }

 
  
});

(function() {
  if (document.body.getAttribute('template') !== 'product') return;

  var el = document.querySelector('.itg_visitors_wrap[data-min]');
  if (!el) return;

  var min      = parseInt(el.dataset.min) || 100;
  var max      = parseInt(el.dataset.max) || 500;
  var interval = parseInt(el.dataset.interval) || 1000;
  var counter  = el.querySelector('.itg_visitor_count');

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  var current = getRandom(min, max);
  counter.textContent = current;

  setInterval(function() {
    var change = Math.floor(Math.random() * 5) + 1;
    var direction = Math.random() > 0.5 ? 1 : -1;
    current = current + (change * direction);
    if (current < min) current = min;
    if (current > max) current = max;
    counter.textContent = current;
  }, interval);
})();

/* === Desktop main nav: hover-to-open coexists with native click ===
   Independent IIFE that re-enables hover-open. Click on summary still works
   (native toggle); if user clicks a hover-opened panel we treat the click as
   "pin" so the panel survives the subsequent mouseleave. */
(function () {
  var mql = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function closeAllHover(except) {
    document.querySelectorAll('.itg_header_menu details.mega-menu[open]').forEach(function (d) {
      if (d !== except) {
        d.removeAttribute('open');
        d.removeAttribute('data-itg-hover-open');
      }
    });
  }

  function bind() {
    document.querySelectorAll('.itg_header_menu li.itg_section').forEach(function (li) {
      if (li.dataset.itgHoverBound === '1') return;
      var details = li.querySelector('details.mega-menu');
      if (!details) return;
      var summary = details.querySelector('summary');
      var closeTimer = null;

      li.addEventListener('mouseenter', function () {
        if (!mql.matches) return;
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          closeAllHover(details);
          details.setAttribute('open', '');
          details.setAttribute('data-itg-hover-open', '1');
        }
      });

      li.addEventListener('mouseleave', function () {
        if (!mql.matches) return;
        if (details.getAttribute('data-itg-hover-open') !== '1') return;
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          details.removeAttribute('data-itg-hover-open');
        }, 150);
      });

      if (summary) {
        summary.addEventListener('click', function (e) {
          if (details.getAttribute('data-itg-hover-open') === '1') {
            details.removeAttribute('data-itg-hover-open');
            e.preventDefault();
          }
        });
      }

      li.dataset.itgHoverBound = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* === Desktop mega menu: X close button === */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.itg-mm-panel__close');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var details = btn.closest('details.mega-menu');
    if (!details) return;
    details.removeAttribute('open');
    details.removeAttribute('data-itg-hover-open');
  });
})();


(function() {
  const chat = document.querySelector('shopify-chat');
  const body = document.body;
  const className = 'chat-is-open';
  
  if (chat) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          if (chat.hasAttribute('open')) {
            body.classList.add(className);
          } else {
            body.classList.remove(className);
          }
        }
      });
    });
    
    observer.observe(chat, {
      attributes: true,
      attributeFilter: ['open']
    });
  }
})();

// Align Shopify Chat button with the Rewards button (custom .tgg-fab, or Smile's own launcher)
(function () {
  function align() {
    const chat = document.querySelector('shopify-chat');
    const smile = document.querySelector('.tgg-fab--rewards') ||
      document.getElementById('smile-ui-lite-launcher-frame-container') ||
      document.querySelector('#smile-ui-container .smile-launcher-frame-container');
    if (!chat || !smile || chat.hasAttribute('open')) return;
    const activator = chat.shadowRoot && chat.shadowRoot.querySelector('.activator');
    if (!activator) return;
    const a = activator.getBoundingClientRect();
    const s = smile.getBoundingClientRect();
    if (!a.height || !s.height) return;

    const delta = (a.top + a.bottom) / 2 - (s.top + s.bottom) / 2;
    if (Math.abs(delta) < 1) return;
    const current = parseFloat(getComputedStyle(chat).getPropertyValue('--shopify-chat-activator-offset')) || 20;
    chat.style.setProperty('--shopify-chat-activator-offset', Math.round(current + delta) + 'px');
  }
    /* DISABLED 2026-10-31 (Grok Bot): measuring and nudging Chat on a timer and on every
     resize made it drift on iPhone (Safari fires resize while its toolbar slides), and it
     copied the sticky-bar lift onto Chat. Chat now gets the same CSS bottom value as
     Rewards in snippets/floating-buttons.liquid. align() is kept for reference only. */
  void align;
})();

//smile button size fix
(function () {
  const CONTAINER_ID = 'smile-ui-lite-launcher-frame-container';
  const IFRAME_ID = 'smile-lite-launcher-frame';
  const STYLE_ID = 'my-smile-override';

  const IFRAME_CSS = `
    button {
      font-size: 13px !important;
      font-family: 'Poppins', arial, sans-serif !important;
      padding: 10px 15px !important;
      height: 46px !important;
      max-height: 46px !important;
      line-height: normal !important;
    }
    button img {
      width: 24px !important;
      height: 24px !important;
    }
  `;

  function applyStyles() {
    const container = document.getElementById(CONTAINER_ID);
    const iframe = document.getElementById(IFRAME_ID);
    if (!container || !iframe) return;

    container.style.setProperty('height', '46px', 'important');
    container.style.setProperty('max-height', '46px', 'important');

    try {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      if (!doc || !doc.head) return;

      let tag = doc.getElementById(STYLE_ID);
      if (!tag) {
        tag = doc.createElement('style');
        tag.id = STYLE_ID;
        doc.head.appendChild(tag);
      }
      if (tag.textContent !== IFRAME_CSS) {
        tag.textContent = IFRAME_CSS;
      }
    } catch (e) {
    }
  }

  function hookIframeLoad() {
    const iframe = document.getElementById(IFRAME_ID);
    if (iframe && !iframe.__smileHooked) {
      iframe.__smileHooked = true;
      iframe.addEventListener('load', applyStyles);
    }
  }

  const observer = new MutationObserver(function () {
    hookIframeLoad();
    applyStyles();
  });

  function start() {
    hookIframeLoad();
    applyStyles();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();

// FIX [COMBO-FILTER] Variant option-combination filter for the custom bundle templates
// (irons-sell-as-set family). These templates are excluded from Dawn's picker re-render in
// product-info.js (that exclusion protects checkbox state and must stay), so their dropdowns
// never learn the real variant matrix: customers could select a combination that matches no
// variant — the price hid and add-to-cart silently did nothing. This self-contained module:
//   - is gated on the [data-variant-matrix] JSON rendered by buy-buttons.liquid for these
//     templates only, and additionally bails out unless the picker is the dropdown type —
//     a hard no-op everywhere else;
//   - cascade-filters each dropdown against the selections of the dropdowns BEFORE it (the
//     same preceding-options semantics Dawn's own re-render uses, so every existing variant
//     stays reachable): values forming NO existing combination are DETACHED from the select
//     into a per-select stash and re-inserted at their original positions on every pass
//     (FIX [COMBO-FILTER-SAFARI]: Safari's native popup ignores `hidden`/CSS on <option>, so
//     hiding is not enough), values whose every matching variant is unavailable stay visible
//     but disabled with the theme's value_unavailable label (Safari respects disabled);
//   - auto-snaps a dropdown whose current value became invalid and then fires a real bubbling
//     'change' event so the whole existing pipeline (VariantSelects publish → section fetch →
//     price update, var-quantity/data-addon-quantity flow, BUNDLE-QTY map lookup at submit)
//     runs naturally — select values are never changed silently;
//   - re-runs on pageshow to reconcile browser form restoration (the same silent-select-change
//     mechanism behind the BUNDLE-QTY stale-quantity bug);
//   - on load only, if the initially selected combination exists but is sold out and another
//     variant is available, snaps to the first available variant; if nothing is available the
//     theme's existing sold-out behavior is left untouched.
// It does NOT touch VariantSelects/setQuantityFromVarAttribute in global.js, the exclusion
// list in product-info.js, or any BUNDLE-QTY logic.
(function () {
  var itgComboReconcilers = [];

  function itgComboSetup(itgProductInfo) {
    if (!itgProductInfo || itgProductInfo.dataset.itgComboFilter === '1') return; // idempotent per element
    var itgMatrixEl = itgProductInfo.querySelector('script[data-variant-matrix]');
    if (!itgMatrixEl) return; // feature gated on the matrix JSON — no-op for every other template/product
    var itgMatrix = null;
    try { itgMatrix = JSON.parse(itgMatrixEl.textContent); } catch (itgErr) { itgMatrix = null; }
    if (!Array.isArray(itgMatrix) || !itgMatrix.length || !Array.isArray(itgMatrix[0].options)) return;
    var itgVariantSelects = itgProductInfo.querySelector('variant-selects');
    if (!itgVariantSelects) return;
    // scoped to this product-info's picker; DOM order matches option position order (Liquid forloop)
    var itgSelects = Array.prototype.slice.call(
      itgVariantSelects.querySelectorAll('.product-form__input--dropdown select.select__select')
    );
    // dropdown pickers only: pill/checkbox pickers on these templates keep their existing behavior,
    // and a mixed/partial picker (select count != option count) is left alone rather than misfiltered
    if (!itgSelects.length || itgSelects.length !== itgMatrix[0].options.length) return;
    itgProductInfo.dataset.itgComboFilter = '1';

    var itgApplying = false; // re-entrancy guard: change events we dispatch must not re-trigger the filter

    // FIX [COMBO-FILTER-SAFARI] per-select stash of detached non-existent <option> nodes with
    // their original index in the FULL option list. Safari's native popup renders `hidden`
    // options anyway, so impossible values must leave the DOM entirely; every filter pass first
    // restores the full list, then re-classifies and detaches fresh.
    var itgStash = new WeakMap(); // select -> [{itgNode, itgIndex}] in ascending original order

    function itgRestoreOptions(itgSelect) {
      // FIX [COMBO-FILTER-SAFARI] entries are in ascending original index order, so inserting
      // each before the node currently at its index (or appending past the end) reproduces the
      // original option order exactly; restoring never moves the selection off the selected node
      var itgEntries = itgStash.get(itgSelect);
      if (!itgEntries || !itgEntries.length) return;
      for (var itgE = 0; itgE < itgEntries.length; itgE++) {
        itgSelect.insertBefore(itgEntries[itgE].itgNode, itgSelect.options[itgEntries[itgE].itgIndex] || null);
      }
      itgStash.set(itgSelect, []);
    }

    function itgSoldOutLabel(itgValue) {
      // same label the theme's own re-render uses (product-variant-options.liquid value_unavailable)
      var itgTpl = window.variantStrings && window.variantStrings.unavailable_with_option;
      return itgTpl ? itgTpl.replace('[value]', itgValue) : itgValue + ' - Sold out';
    }

    function itgMatchesPreceding(itgVariant, itgPos) {
      for (var itgJ = 0; itgJ < itgPos; itgJ++) {
        if (itgVariant.options[itgJ] !== itgSelects[itgJ].value) return false;
      }
      return true;
    }

    function itgFindVariant() {
      for (var itgK = 0; itgK < itgMatrix.length; itgK++) {
        var itgAll = true;
        for (var itgJ = 0; itgJ < itgSelects.length; itgJ++) {
          if (itgMatrix[itgK].options[itgJ] !== itgSelects[itgJ].value) { itgAll = false; break; }
        }
        if (itgAll) return itgMatrix[itgK];
      }
      return null;
    }

    function itgApply() {
      if (itgApplying) return;
      itgApplying = true;
      try {
        var itgChanged = [];
        for (var itgI = 0; itgI < itgSelects.length; itgI++) {
          var itgSelect = itgSelects[itgI];
          itgRestoreOptions(itgSelect); // FIX [COMBO-FILTER-SAFARI] full option list back before classifying
          var itgExisting = {};  // option value -> at least one variant matches (given preceding selections)
          var itgAvailable = {}; // option value -> at least one of those variants is purchasable
          for (var itgK = 0; itgK < itgMatrix.length; itgK++) {
            if (!itgMatchesPreceding(itgMatrix[itgK], itgI)) continue;
            var itgVal = itgMatrix[itgK].options[itgI];
            itgExisting[itgVal] = true;
            if (itgMatrix[itgK].available) itgAvailable[itgVal] = true;
          }
          var itgFirstAvailable = null;
          var itgFirstExisting = null;
          // FIX [COMBO-FILTER-SAFARI] capture the value BEFORE detaching: removing the selected
          // node makes the browser silently move the selection, so the snap decision below must
          // not trust itgSelect.value once nodes have been detached
          var itgPrevValue = itgSelect.value;
          var itgToStash = [];
          // static snapshot with indexes into the full restored list — these indexes are what the
          // stash stores so itgRestoreOptions can reproduce the original order next pass
          var itgOptions = Array.prototype.slice.call(itgSelect.options);
          for (var itgO = 0; itgO < itgOptions.length; itgO++) {
            var itgOpt = itgOptions[itgO];
            var itgOptVal = itgOpt.value;
            // base label = the raw option value; also normalizes any "(Unavailable)" text Liquid
            // baked in at first render (frozen-at-load context, since these templates never re-render)
            if (itgOpt.dataset.itgBaseLabel === undefined) itgOpt.dataset.itgBaseLabel = itgOptVal;
            if (!itgExisting[itgOptVal]) {
              // FIX [COMBO-FILTER-SAFARI] no variant exists for this value with the current
              // preceding selections → detach into the stash (Safari renders hidden options)
              itgToStash.push({ itgNode: itgOpt, itgIndex: itgO });
            } else if (!itgAvailable[itgOptVal]) {
              // exists but every matching variant is sold out → visible, not selectable
              itgOpt.disabled = true;
              itgOpt.textContent = itgSoldOutLabel(itgOpt.dataset.itgBaseLabel);
              if (itgFirstExisting === null) itgFirstExisting = itgOptVal;
            } else {
              itgOpt.disabled = false;
              itgOpt.textContent = itgOpt.dataset.itgBaseLabel;
              if (itgFirstAvailable === null) itgFirstAvailable = itgOptVal;
              if (itgFirstExisting === null) itgFirstExisting = itgOptVal;
            }
          }
          for (var itgS = 0; itgS < itgToStash.length; itgS++) {
            // FIX [COMBO-FILTER-SAFARI] strip Dawn's `selected` attribute from detached nodes:
            // a stale attribute on a restored node would give the select two option[selected]
            // and corrupt VariantSelects.selectedOptionValues; the attribute is re-seated on the
            // attached selection below
            itgToStash[itgS].itgNode.removeAttribute('selected');
            itgToStash[itgS].itgNode.remove();
          }
          if (itgToStash.length) itgStash.set(itgSelect, itgToStash);
          // auto-snap: the pre-detach value forms no existing combination → move to the first
          // valid value (preferring purchasable) so the rest of the cascade and the section fetch
          // always operate on a real combination. The value is set here but ANNOUNCED below via a
          // real event.
          if (!itgExisting[itgPrevValue]) {
            var itgSnapTo = itgFirstAvailable !== null ? itgFirstAvailable : itgFirstExisting;
            if (itgSnapTo !== null) {
              if (itgSelect.value !== itgSnapTo) itgSelect.value = itgSnapTo;
              if (itgSnapTo !== itgPrevValue) itgChanged.push(itgSelect);
            }
          } else if (itgSelect.value !== itgPrevValue) {
            // FIX [COMBO-FILTER-SAFARI] defensive: the browser moved the selection while a node
            // was detached even though the previous value still exists — put it back
            itgSelect.value = itgPrevValue;
          }
          // FIX [COMBO-FILTER-SAFARI] re-seat the `selected` attribute if its carrier was
          // stashed: updateSelectionMetadata (global.js:1084) crashes when no attached option has
          // it, and selectedOptionValues would drop this select from the section-fetch params
          if (!itgSelect.querySelector('option[selected]') && itgSelect.selectedIndex >= 0) {
            itgSelect.options[itgSelect.selectedIndex].setAttribute('selected', 'selected');
          }
        }
        // dispatch AFTER the whole cascade is consistent; events are synchronous and product-info
        // aborts superseded fetches, so the last fetch always reflects the final selection
        for (var itgC = 0; itgC < itgChanged.length; itgC++) {
          itgChanged[itgC].dispatchEvent(new Event('change', { bubbles: true }));
        }
      } finally {
        itgApplying = false;
      }
    }

    function itgReconcile() {
      itgApply();
      // load/pageshow only: never selectable via the UI once filtered, but the server-rendered or
      // browser-restored initial selection can be a sold-out variant — snap to the first available
      var itgCurrent = itgFindVariant();
      if (itgCurrent && !itgCurrent.available) {
        var itgFirstAvail = null;
        for (var itgK = 0; itgK < itgMatrix.length; itgK++) {
          if (itgMatrix[itgK].available) { itgFirstAvail = itgMatrix[itgK]; break; }
        }
        if (itgFirstAvail) {
          var itgChanged = [];
          for (var itgJ = 0; itgJ < itgSelects.length; itgJ++) {
            // FIX [COMBO-FILTER-SAFARI] the target option may be sitting in the stash (setting
            // select.value to a detached option's value silently no-ops) — restore first; the
            // itgApply() below re-detaches whatever is invalid for the new selection
            itgRestoreOptions(itgSelects[itgJ]);
            if (itgSelects[itgJ].value !== itgFirstAvail.options[itgJ]) {
              itgSelects[itgJ].value = itgFirstAvail.options[itgJ];
              itgChanged.push(itgSelects[itgJ]);
            }
          }
          if (itgChanged.length) {
            itgApply(); // re-filter for the new selection before announcing it
            for (var itgC = 0; itgC < itgChanged.length; itgC++) {
              itgChanged[itgC].dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
        // no purchasable variant at all → leave the theme's existing sold-out behavior untouched
      }
    }

    itgVariantSelects.addEventListener('change', function (itgEvt) {
      if (itgApplying) return; // ignore the change events this module dispatches itself
      if (itgEvt.target && itgEvt.target.tagName === 'SELECT') itgApply();
    });

    itgComboReconcilers.push(itgReconcile);
    itgReconcile();
  }

  function itgComboInitAll() {
    document.querySelectorAll('product-info').forEach(function (itgEl) { itgComboSetup(itgEl); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', itgComboInitAll);
  } else {
    itgComboInitAll();
  }
  // product-info swapped/inserted later (combined-listing swap, quick-add) announces itself
  document.addEventListener('product-info:loaded', function (itgEvt) {
    var itgEl = itgEvt.target && itgEvt.target.closest ? itgEvt.target.closest('product-info') : null;
    if (itgEl) itgComboSetup(itgEl);
  });
  // back/forward: the theme force-reloads, then browser form restoration can silently change the
  // selects after load (the BUNDLE-QTY bug mechanism) — reconcile to a valid state on pageshow
  window.addEventListener('pageshow', function () {
    for (var itgR = 0; itgR < itgComboReconcilers.length; itgR++) itgComboReconcilers[itgR]();
  });
})();

// FIX [COMBO-SNAP] Auto-snap companion to FIX [COMBO-FILTER-LIQUID] for the RE-RENDERED
// (non-excluded) templates, e.g. the default product template. There, the Liquid skip in
// product-variant-options.liquid removes non-existent combination values on every server
// re-render, EXCEPT the currently selected value (Dawn's selected-option pipeline needs
// option[selected] in the DOM). UX gap: change a preceding option and your current selection can
// become an impossible combination — it stays selected as "- Unavailable" with a disabled button
// until the user re-picks by hand. This module snaps such a selection to the first EXISTING
// (preferring available) value and announces it with a real bubbling 'change' event so the whole
// normal pipeline (VariantSelects → section fetch → price/button/media update) runs — never a
// silent value set. Design notes:
//   - Re-render hook: a MutationObserver on the stable <product-info> element. Dawn's
//     updateOptionValues (product-info.js) swaps the picker via HTMLUpdateUtility.viewTransition
//     (global.js), which INSERTS a brand-new <variant-selects> node (old one is hidden, removed
//     500ms later) — so a childList mutation fires for every swap. The variantChange PUB_SUB
//     event is deliberately NOT used: handleUpdateProductInfo returns early (setUnavailable)
//     BEFORE publishing it exactly when the fetched selection matches no variant — which is
//     precisely the case this module must react to.
//   - Existence source: the <script data-selected-variant> JSON that product-variant-picker.liquid
//     re-renders inside every new variant-selects. Shopify renders it as the literal `null` when
//     the option_values selection matches no variant (verified on the live store) — a
//     server-authoritative signal needing no variant matrix (data-variant-matrix does not exist on
//     these templates) and no extra requests. DOM labels alone cannot distinguish "selected but
//     sold out" (must stay, per the sold-out contract) from "selected but non-existent" — the
//     null JSON can.
//   - Which dropdown to snap: walk BACKWARDS from the last dropdown. When the JSON is null, the
//     LAST dropdown's selected value provably forms no variant with the preceding selections
//     (if it did, that variant would BE the full selection and the JSON would be non-null), so
//     snapping the deepest labeled dropdown always targets a genuinely non-existent combination
//     and never disturbs a shallower existing-but-sold-out selection. Every NON-selected option
//     the re-render left in a dropdown is guaranteed existing w.r.t. the preceding selections
//     (the Liquid skip removed the rest), so any of them is a valid snap target; ones whose text
//     equals their value are also in stock (unavailable ones carry the value_unavailable label) —
//     preferred. If a dropdown has no alternative options its own preceding selection is broken —
//     step one dropdown shallower. Each snap triggers a re-render; the observer re-checks and
//     converges (one pass per broken level, hard-capped).
//   - Loop guards: itgSnapApplying suppresses reactions to this module's own change dispatch;
//     itgSnapPasses caps consecutive auto-snaps (reset by any user-originated change or by a
//     check that finds a real variant), so a pathological state can never ping-pong fetches.
//   - Hard no-ops: excluded bundle templates (same suffix list as product-info.js's re-render
//     exclusion — those never re-render and the itgComboSetup module above owns them), any
//     product-info containing data-variant-matrix (belt and braces for embedded bundle markup),
//     and pill/swatch pickers (dropdown selects only).
// It does NOT touch the Liquid skip, the COMBO-FILTER module above, product-info.js, global.js,
// or any BUNDLE-QTY code.
(function () {
  // FIX [COMBO-SNAP] mirror of the updateOptionValues exclusion list in product-info.js — on
  // these templates the picker never re-renders and the JS combo-filter module owns filtering
  var itgSnapExcluded = [
    'custom-driver-fw-hy', 'new-custom-driver-fairway', 'new-custom-parallel-iron',
    'custom-driver-fairway-woo', 'custom-iron-wedge-shaft', 'parallel-custom-iron-wedg',
    'custom-taylormade-putters', 'irons-sell-as-set', 'default-clubs', 'default-shafts',
    'default-all-other-items'
  ];

  function itgSnapSetup(itgProductInfo) {
    if (!itgProductInfo || itgProductInfo.dataset.itgComboSnap === '1') return; // idempotent per element
    var itgSuffix = document.body.getAttribute('data-template') || '';
    if (itgSnapExcluded.indexOf(itgSuffix) !== -1) return; // bundle templates: JS combo-filter owns them
    if (itgProductInfo.querySelector('script[data-variant-matrix]')) return; // bundle markup present: not ours
    if (!itgProductInfo.querySelector('variant-selects script[data-selected-variant]')) return; // no signal, no action
    itgProductInfo.dataset.itgComboSnap = '1';

    var itgSnapApplying = false; // re-entrancy: ignore the change events this module dispatches
    var itgSnapPasses = 0;       // consecutive auto-snap counter (loop guard)
    var itgSnapScheduled = false;

    // always re-query: viewTransition REPLACES variant-selects on every re-render, so cached
    // element references would go stale after the first change. querySelector returns the NEW
    // node (inserted before the hidden old one) during the 500ms overlap window.
    function itgSnapPicker() {
      var itgVS = itgProductInfo.querySelector('variant-selects');
      if (!itgVS) return null;
      // dropdown pickers only — pill/swatch pickers keep their existing behavior untouched
      if (itgVS.querySelector('.product-form__input--swatch, .product-form__input--pill')) return null;
      var itgSelects = itgVS.querySelectorAll('.product-form__input--dropdown select.select__select');
      if (itgSelects.length < 2) return null; // single-option products: position 1 is never filtered
      return { itgVS: itgVS, itgSelects: Array.prototype.slice.call(itgSelects) };
    }

    // true only when the server said the current selection matches NO variant (JSON is `null`);
    // a sold-out selection returns a full variant object here and must NOT be snapped
    function itgSnapVariantIsNull(itgVS) {
      var itgEl = itgVS.querySelector('script[data-selected-variant]');
      if (!itgEl) return false;
      try { return JSON.parse(itgEl.textContent) === null; } catch (itgErr) { return false; }
    }

    // the Liquid dropdown branch renders a plain option's text identical to its value; only the
    // value_unavailable label makes them differ — locale-proof, no string constants needed
    function itgSnapIsLabeled(itgOpt) {
      return itgOpt.textContent.trim() !== itgOpt.value.trim();
    }

    function itgSnapCheck() {
      if (itgSnapApplying) return;
      var itgPicker = itgSnapPicker();
      if (!itgPicker) return;
      if (!itgSnapVariantIsNull(itgPicker.itgVS)) { itgSnapPasses = 0; return; } // real variant (even sold out): no-op
      if (itgSnapPasses > itgPicker.itgSelects.length) return; // loop guard: converged or pathological — stop
      // deepest-first: see design notes — the last dropdown's selected value is provably
      // non-existent when the JSON is null; shallower levels only matter when a dropdown has no
      // alternative options (its own preceding selection is the broken one)
      for (var itgI = itgPicker.itgSelects.length - 1; itgI >= 1; itgI--) {
        var itgSelect = itgPicker.itgSelects[itgI];
        var itgCurrent = itgSelect.selectedIndex >= 0 ? itgSelect.options[itgSelect.selectedIndex] : null;
        if (!itgCurrent || !itgSnapIsLabeled(itgCurrent)) continue; // this level's selection is fine
        var itgAvailableTarget = null;
        var itgExistingTarget = null;
        for (var itgO = 0; itgO < itgSelect.options.length; itgO++) {
          var itgOpt = itgSelect.options[itgO];
          if (itgOpt === itgCurrent) continue;
          if (!itgSnapIsLabeled(itgOpt)) { itgAvailableTarget = itgOpt; break; } // existing + in stock
          if (itgExistingTarget === null) itgExistingTarget = itgOpt; // existing but sold out
        }
        var itgTarget = itgAvailableTarget || itgExistingTarget;
        if (!itgTarget) continue; // no alternatives here → the break is shallower, keep walking up
        itgSnapPasses++;
        itgSnapApplying = true;
        try {
          itgSelect.value = itgTarget.value;
          // real bubbling event: VariantSelects' own handler moves option[selected], publishes,
          // and product-info re-fetches — the observer then re-checks against the fresh render
          itgSelect.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          itgSnapApplying = false;
        }
        return; // one snap per pass; convergence is verified on the next re-render
      }
    }

    function itgSnapSchedule() {
      if (itgSnapScheduled) return;
      itgSnapScheduled = true;
      requestAnimationFrame(function () {
        itgSnapScheduled = false;
        itgSnapCheck();
      });
    }

    // re-render completion hook (see design notes): fires on every viewTransition swap, including
    // the null-variant path where the variantChange publish is skipped
    var itgSnapObserver = new MutationObserver(function (itgRecords) {
      for (var itgR = 0; itgR < itgRecords.length; itgR++) {
        var itgAdded = itgRecords[itgR].addedNodes;
        for (var itgN = 0; itgN < itgAdded.length; itgN++) {
          var itgNode = itgAdded[itgN];
          if (itgNode.nodeType === 1 &&
              (itgNode.tagName === 'VARIANT-SELECTS' || (itgNode.querySelector && itgNode.querySelector('variant-selects')))) {
            itgSnapSchedule();
            return;
          }
        }
      }
    });
    itgSnapObserver.observe(itgProductInfo, { childList: true, subtree: true });

    // any change this module did NOT dispatch is user interaction — restore the snap budget
    itgProductInfo.addEventListener('change', function (itgEvt) {
      if (!itgSnapApplying && itgEvt.target && itgEvt.target.tagName === 'SELECT') itgSnapPasses = 0;
    });

    itgSnapCheck(); // initial state (deep links render a real variant, so this is normally a no-op)
  }

  function itgSnapInitAll() {
    document.querySelectorAll('product-info').forEach(function (itgEl) { itgSnapSetup(itgEl); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', itgSnapInitAll);
  } else {
    itgSnapInitAll();
  }
  // product-info swapped/inserted later (combined-listing swap, quick-add) announces itself
  document.addEventListener('product-info:loaded', function (itgEvt) {
    var itgEl = itgEvt.target && itgEvt.target.closest ? itgEvt.target.closest('product-info') : null;
    if (itgEl) itgSnapSetup(itgEl);
  });
  // back/forward: browser form restoration can silently change the selects after the theme's
  // forced reload, leaving the rendered option lists and the data-selected-variant JSON stale
  // relative to the restored values. Announce every select whose live value no longer matches its
  // server-rendered option[selected] with a real change event — the normal pipeline re-fetches and
  // the MutationObserver re-checks against the fresh, trustworthy render.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('product-info').forEach(function (itgPI) {
      if (itgPI.dataset.itgComboSnap !== '1') return;
      var itgVS = itgPI.querySelector('variant-selects');
      if (!itgVS) return;
      itgVS.querySelectorAll('.product-form__input--dropdown select.select__select').forEach(function (itgSelect) {
        var itgMarked = itgSelect.querySelector('option[selected]');
        var itgCurrent = itgSelect.selectedIndex >= 0 ? itgSelect.options[itgSelect.selectedIndex] : null;
        if (itgMarked && itgCurrent && itgMarked !== itgCurrent) {
          itgSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
})();

// Required-option validation for the custom templates that use the native
// add-to-cart submit (default-clubs / default-shafts / default-all-other-items
// have no add_multiple span, so the walk in validation() never runs there).
// Blocks the submit until the walk passes. Scoped to the main product form:
// quick-add forms for other products must pass through untouched.
(function () {
  function suffix() {
    return document.body ? document.body.getAttribute('data-template') : null;
  }
  document.addEventListener('submit', function (e) {
    if (['default-clubs', 'default-shafts', 'default-all-other-items'].indexOf(suffix()) === -1) return;
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var anyField = document.querySelector('select.itg-error[form]') || document.querySelector('select.itg-error');
    if (!anyField) return; // this product renders no custom options
    var fieldFormId = anyField.getAttribute('form');
    if (fieldFormId && form.id !== fieldFormId) return; // not the form the custom fields belong to
    if (typeof window.itgRunValidationWalk === 'function' && !window.itgRunValidationWalk()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    }
  }, true);
})();

/* === Searchanise filters: keep the shopper where they are while results refresh === */
(function () {
  var RESULTS = '#snize_results';
  var pending = null;

  function resultsEl() {
    return document.querySelector(RESULTS);
  }

  function arm(kind) {
    var el = resultsEl();
    if (!el) return;
    if (pending) {
      clearTimeout(pending.timer);
    } else {
      el.style.minHeight = el.offsetHeight + 'px';
    }
    pending = { y: window.scrollY, kind: kind, timer: setTimeout(finish, 5000) };
  }

  function restore() {
    if (pending && Math.abs(window.scrollY - pending.y) > 1) {
      window.scrollTo(0, pending.y);
    }
  }

  function finish() {
    if (!pending) return;
    var y = pending.y;
    clearTimeout(pending.timer);
    pending = null;
    var el = resultsEl();
    if (!el) return;
    el.style.minHeight = '';
    var maxY = document.documentElement.scrollHeight - window.innerHeight;
    if (y <= maxY) {
      window.scrollTo(0, y);
      return;
    }
    var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--itg-sticky-offset')) || 0;
    var gap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--itg-sticky-gap')) || 0;
    var top = el.getBoundingClientRect().top + window.scrollY - offset - gap;
    window.scrollTo(0, Math.max(0, Math.min(top, maxY)));
  }

  // Capture phase: runs before the widget's own handlers, some of which stop
  // propagation.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest(RESULTS + ' .snize-product-filters-checkbox')) arm('checkbox');
  }, true);
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest(RESULTS + ' .snize-price-range-slider')) arm('other');
  }, true);
  function onReset(e) {
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    if (e.target.closest && e.target.closest(
      RESULTS + ' .snize-product-filters-reset, ' +
      RESULTS + ' .snize-product-filters-reset-all, ' +
      RESULTS + ' .snize-product-filters-reset-button, ' +
      RESULTS + ' .snize-product-filters-clear'
    )) arm('other');
  }
  document.addEventListener('click', onReset, true);
  document.addEventListener('keydown', onReset, true);

  function bind() {
    var $ = window.Searchanise && window.Searchanise.$;
    if (!$) return;
    $(document).on('Searchanise.ResultsUpdated', function () {
      if (!pending) return;
      restore();
      // Checkbox changes still have the widget's delayed focus() to come;
      // FilterValueClicked fires right after it.
      if (pending.kind !== 'checkbox') finish();
    });
    $(document).on('Searchanise.FilterValueClicked', function () {
      restore();
      finish();
    });
  }

  if (window.Searchanise && window.Searchanise.Loaded) {
    bind();
  } else {
    document.addEventListener('Searchanise.Loaded', bind);
  }
})();